(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8826],{

/***/ 78816:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory) {
    'use strict';
    // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.

    /* istanbul ignore next */
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(94170)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {}
}(this, function ErrorStackParser(StackFrame) {
    'use strict';

    var FIREFOX_SAFARI_STACK_REGEXP = /(^|@)\S+:\d+/;
    var CHROME_IE_STACK_REGEXP = /^\s*at .*(\S+:\d+|\(native\))/m;
    var SAFARI_NATIVE_CODE_REGEXP = /^(eval@)?(\[native code])?$/;

    return {
        /**
         * Given an Error object, extract the most information from it.
         *
         * @param {Error} error object
         * @return {Array} of StackFrames
         */
        parse: function ErrorStackParser$$parse(error) {
            if (typeof error.stacktrace !== 'undefined' || typeof error['opera#sourceloc'] !== 'undefined') {
                return this.parseOpera(error);
            } else if (error.stack && error.stack.match(CHROME_IE_STACK_REGEXP)) {
                return this.parseV8OrIE(error);
            } else if (error.stack) {
                return this.parseFFOrSafari(error);
            } else {
                throw new Error('Cannot parse given Error object');
            }
        },

        // Separate line and column numbers from a string of the form: (URI:Line:Column)
        extractLocation: function ErrorStackParser$$extractLocation(urlLike) {
            // Fail-fast but return locations like "(native)"
            if (urlLike.indexOf(':') === -1) {
                return [urlLike];
            }

            var regExp = /(.+?)(?::(\d+))?(?::(\d+))?$/;
            var parts = regExp.exec(urlLike.replace(/[()]/g, ''));
            return [parts[1], parts[2] || undefined, parts[3] || undefined];
        },

        parseV8OrIE: function ErrorStackParser$$parseV8OrIE(error) {
            var filtered = error.stack.split('\n').filter(function(line) {
                return !!line.match(CHROME_IE_STACK_REGEXP);
            }, this);

            return filtered.map(function(line) {
                if (line.indexOf('(eval ') > -1) {
                    // Throw away eval information until we implement stacktrace.js/stackframe#8
                    line = line.replace(/eval code/g, 'eval').replace(/(\(eval at [^()]*)|(,.*$)/g, '');
                }
                var sanitizedLine = line.replace(/^\s+/, '').replace(/\(eval code/g, '(').replace(/^.*?\s+/, '');

                // capture and preseve the parenthesized location "(/foo/my bar.js:12:87)" in
                // case it has spaces in it, as the string is split on \s+ later on
                var location = sanitizedLine.match(/ (\(.+\)$)/);

                // remove the parenthesized location from the line, if it was matched
                sanitizedLine = location ? sanitizedLine.replace(location[0], '') : sanitizedLine;

                // if a location was matched, pass it to extractLocation() otherwise pass all sanitizedLine
                // because this line doesn't have function name
                var locationParts = this.extractLocation(location ? location[1] : sanitizedLine);
                var functionName = location && sanitizedLine || undefined;
                var fileName = ['eval', '<anonymous>'].indexOf(locationParts[0]) > -1 ? undefined : locationParts[0];

                return new StackFrame({
                    functionName: functionName,
                    fileName: fileName,
                    lineNumber: locationParts[1],
                    columnNumber: locationParts[2],
                    source: line
                });
            }, this);
        },

        parseFFOrSafari: function ErrorStackParser$$parseFFOrSafari(error) {
            var filtered = error.stack.split('\n').filter(function(line) {
                return !line.match(SAFARI_NATIVE_CODE_REGEXP);
            }, this);

            return filtered.map(function(line) {
                // Throw away eval information until we implement stacktrace.js/stackframe#8
                if (line.indexOf(' > eval') > -1) {
                    line = line.replace(/ line (\d+)(?: > eval line \d+)* > eval:\d+:\d+/g, ':$1');
                }

                if (line.indexOf('@') === -1 && line.indexOf(':') === -1) {
                    // Safari eval frames only have function names and nothing else
                    return new StackFrame({
                        functionName: line
                    });
                } else {
                    var functionNameRegex = /((.*".+"[^@]*)?[^@]*)(?:@)/;
                    var matches = line.match(functionNameRegex);
                    var functionName = matches && matches[1] ? matches[1] : undefined;
                    var locationParts = this.extractLocation(line.replace(functionNameRegex, ''));

                    return new StackFrame({
                        functionName: functionName,
                        fileName: locationParts[0],
                        lineNumber: locationParts[1],
                        columnNumber: locationParts[2],
                        source: line
                    });
                }
            }, this);
        },

        parseOpera: function ErrorStackParser$$parseOpera(e) {
            if (!e.stacktrace || (e.message.indexOf('\n') > -1 &&
                e.message.split('\n').length > e.stacktrace.split('\n').length)) {
                return this.parseOpera9(e);
            } else if (!e.stack) {
                return this.parseOpera10(e);
            } else {
                return this.parseOpera11(e);
            }
        },

        parseOpera9: function ErrorStackParser$$parseOpera9(e) {
            var lineRE = /Line (\d+).*script (?:in )?(\S+)/i;
            var lines = e.message.split('\n');
            var result = [];

            for (var i = 2, len = lines.length; i < len; i += 2) {
                var match = lineRE.exec(lines[i]);
                if (match) {
                    result.push(new StackFrame({
                        fileName: match[2],
                        lineNumber: match[1],
                        source: lines[i]
                    }));
                }
            }

            return result;
        },

        parseOpera10: function ErrorStackParser$$parseOpera10(e) {
            var lineRE = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i;
            var lines = e.stacktrace.split('\n');
            var result = [];

            for (var i = 0, len = lines.length; i < len; i += 2) {
                var match = lineRE.exec(lines[i]);
                if (match) {
                    result.push(
                        new StackFrame({
                            functionName: match[3] || undefined,
                            fileName: match[2],
                            lineNumber: match[1],
                            source: lines[i]
                        })
                    );
                }
            }

            return result;
        },

        // Opera 10.65+ Error.stack very similar to FF/Safari
        parseOpera11: function ErrorStackParser$$parseOpera11(error) {
            var filtered = error.stack.split('\n').filter(function(line) {
                return !!line.match(FIREFOX_SAFARI_STACK_REGEXP) && !line.match(/^Error created at/);
            }, this);

            return filtered.map(function(line) {
                var tokens = line.split('@');
                var locationParts = this.extractLocation(tokens.pop());
                var functionCall = (tokens.shift() || '');
                var functionName = functionCall
                    .replace(/<anonymous function(: (\w+))?>/, '$2')
                    .replace(/\([^)]*\)/g, '') || undefined;
                var argsRaw;
                if (functionCall.match(/\(([^)]*)\)/)) {
                    argsRaw = functionCall.replace(/^[^(]+\(([^)]*)\)$/, '$1');
                }
                var args = (argsRaw === undefined || argsRaw === '[arguments not available]') ?
                    undefined : argsRaw.split(',');

                return new StackFrame({
                    functionName: functionName,
                    args: args,
                    fileName: locationParts[0],
                    lineNumber: locationParts[1],
                    columnNumber: locationParts[2],
                    source: line
                });
            }, this);
        }
    };
}));


/***/ }),

/***/ 94170:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory) {
    'use strict';
    // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.

    /* istanbul ignore next */
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {}
}(this, function() {
    'use strict';
    function _isNumber(n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    }

    function _capitalize(str) {
        return str.charAt(0).toUpperCase() + str.substring(1);
    }

    function _getter(p) {
        return function() {
            return this[p];
        };
    }

    var booleanProps = ['isConstructor', 'isEval', 'isNative', 'isToplevel'];
    var numericProps = ['columnNumber', 'lineNumber'];
    var stringProps = ['fileName', 'functionName', 'source'];
    var arrayProps = ['args'];
    var objectProps = ['evalOrigin'];

    var props = booleanProps.concat(numericProps, stringProps, arrayProps, objectProps);

    function StackFrame(obj) {
        if (!obj) return;
        for (var i = 0; i < props.length; i++) {
            if (obj[props[i]] !== undefined) {
                this['set' + _capitalize(props[i])](obj[props[i]]);
            }
        }
    }

    StackFrame.prototype = {
        getArgs: function() {
            return this.args;
        },
        setArgs: function(v) {
            if (Object.prototype.toString.call(v) !== '[object Array]') {
                throw new TypeError('Args must be an Array');
            }
            this.args = v;
        },

        getEvalOrigin: function() {
            return this.evalOrigin;
        },
        setEvalOrigin: function(v) {
            if (v instanceof StackFrame) {
                this.evalOrigin = v;
            } else if (v instanceof Object) {
                this.evalOrigin = new StackFrame(v);
            } else {
                throw new TypeError('Eval Origin must be an Object or StackFrame');
            }
        },

        toString: function() {
            var fileName = this.getFileName() || '';
            var lineNumber = this.getLineNumber() || '';
            var columnNumber = this.getColumnNumber() || '';
            var functionName = this.getFunctionName() || '';
            if (this.getIsEval()) {
                if (fileName) {
                    return '[eval] (' + fileName + ':' + lineNumber + ':' + columnNumber + ')';
                }
                return '[eval]:' + lineNumber + ':' + columnNumber;
            }
            if (functionName) {
                return functionName + ' (' + fileName + ':' + lineNumber + ':' + columnNumber + ')';
            }
            return fileName + ':' + lineNumber + ':' + columnNumber;
        }
    };

    StackFrame.fromString = function StackFrame$$fromString(str) {
        var argsStartIndex = str.indexOf('(');
        var argsEndIndex = str.lastIndexOf(')');

        var functionName = str.substring(0, argsStartIndex);
        var args = str.substring(argsStartIndex + 1, argsEndIndex).split(',');
        var locationString = str.substring(argsEndIndex + 1);

        if (locationString.indexOf('@') === 0) {
            var parts = /@(.+?)(?::(\d+))?(?::(\d+))?$/.exec(locationString, '');
            var fileName = parts[1];
            var lineNumber = parts[2];
            var columnNumber = parts[3];
        }

        return new StackFrame({
            functionName: functionName,
            args: args || undefined,
            fileName: fileName,
            lineNumber: lineNumber || undefined,
            columnNumber: columnNumber || undefined
        });
    };

    for (var i = 0; i < booleanProps.length; i++) {
        StackFrame.prototype['get' + _capitalize(booleanProps[i])] = _getter(booleanProps[i]);
        StackFrame.prototype['set' + _capitalize(booleanProps[i])] = (function(p) {
            return function(v) {
                this[p] = Boolean(v);
            };
        })(booleanProps[i]);
    }

    for (var j = 0; j < numericProps.length; j++) {
        StackFrame.prototype['get' + _capitalize(numericProps[j])] = _getter(numericProps[j]);
        StackFrame.prototype['set' + _capitalize(numericProps[j])] = (function(p) {
            return function(v) {
                if (!_isNumber(v)) {
                    throw new TypeError(p + ' must be a Number');
                }
                this[p] = Number(v);
            };
        })(numericProps[j]);
    }

    for (var k = 0; k < stringProps.length; k++) {
        StackFrame.prototype['get' + _capitalize(stringProps[k])] = _getter(stringProps[k]);
        StackFrame.prototype['set' + _capitalize(stringProps[k])] = (function(p) {
            return function(v) {
                this[p] = String(v);
            };
        })(stringProps[k]);
    }

    return StackFrame;
}));


/***/ }),

/***/ 12566:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.inDocument = exports.isInstance = void 0;
// TODO: we need a type expert here so we won't have to ignore the lines
// TODO: use it everywhere (static function; export from which file? <-- global Window typing required)
function isInstance(node, constr) {
    const doc = node.ownerDocument;
    if (!doc) { // null if Document
        return constr.name === 'Document';
    }
    let context = 
    // @ts-ignore (for EI, Safary)
    doc.parentWindow ||
        doc.defaultView; // TODO: smart global typing for Window object
    while (context.parent && context.parent !== context) {
        // @ts-ignore
        if (node instanceof context[constr.name]) {
            return true;
        }
        // @ts-ignore
        context = context.parent;
    }
    // @ts-ignore
    return node instanceof context[constr.name];
}
exports.isInstance = isInstance;
function inDocument(node) {
    const doc = node.ownerDocument;
    if (!doc) {
        return false;
    }
    if (doc.contains(node)) {
        return true;
    }
    let context = 
    // @ts-ignore (for EI, Safary)
    doc.parentWindow ||
        doc.defaultView;
    while (context.parent && context.parent !== context) {
        if (context.document.contains(node)) {
            return true;
        }
        // @ts-ignore
        context = context.parent;
    }
    return false;
}
exports.inDocument = inDocument;


/***/ }),

/***/ 89441:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DEFAULT_INGEST_POINT = exports.CANCELED = void 0;
const utils_js_1 = __webpack_require__(80901);
const index_js_1 = __webpack_require__(78067);
const nodes_js_1 = __webpack_require__(28931);
const top_observer_js_1 = __webpack_require__(29012);
const sanitizer_js_1 = __webpack_require__(45793);
const ticker_js_1 = __webpack_require__(55857);
const logger_js_1 = __webpack_require__(44621);
const session_js_1 = __webpack_require__(64138);
const performance_js_1 = __webpack_require__(86033);
var ActivityState;
(function (ActivityState) {
    ActivityState[ActivityState["NotActive"] = 0] = "NotActive";
    ActivityState[ActivityState["Starting"] = 1] = "Starting";
    ActivityState[ActivityState["Active"] = 2] = "Active";
})(ActivityState || (ActivityState = {}));
exports.CANCELED = "canceled";
// TODO: use backendHost only
exports.DEFAULT_INGEST_POINT = 'https://api.openreplay.com/ingest';
class App {
    constructor(projectKey, sessionToken, options) {
        // if (options.onStart !== undefined) {
        //   deprecationWarn("'onStart' option", "tracker.start().then(/* handle session info */)")
        // } ?? maybe onStart is good
        this.messages = [];
        this.startCallbacks = [];
        this.stopCallbacks = [];
        this.commitCallbacks = [];
        this.activityState = ActivityState.NotActive;
        this.version = '3.5.3'; // TODO: version compatability check inside each plugin.
        this.preStartMessages = [];
        this.projectKey = projectKey;
        this.options = Object.assign({
            revID: '',
            node_id: '__openreplay_id',
            session_token_key: '__openreplay_token',
            session_pageno_key: '__openreplay_pageno',
            session_reset_key: '__openreplay_reset',
            local_uuid_key: '__openreplay_uuid',
            ingestPoint: exports.DEFAULT_INGEST_POINT,
            resourceBaseHref: null,
            verbose: false,
            __is_snippet: false,
            __debug_report_edp: null,
        }, options);
        if (sessionToken != null) {
            sessionStorage.setItem(this.options.session_token_key, sessionToken);
        }
        this.revID = this.options.revID;
        this.sanitizer = new sanitizer_js_1.default(this, options);
        this.nodes = new nodes_js_1.default(this.options.node_id);
        this.observer = new top_observer_js_1.default(this, options);
        this.ticker = new ticker_js_1.default(this);
        this.ticker.attach(() => this.commit());
        this.debug = new logger_js_1.default(this.options.__debug__);
        this.notify = new logger_js_1.default(this.options.verbose ? logger_js_1.LogLevel.Warnings : logger_js_1.LogLevel.Silent);
        this.session = new session_js_1.default(this);
        try {
            this.worker = new Worker(URL.createObjectURL(new Blob([`"use strict";function t(t){function s(...s){return new t(...s)}return s.prototype=t.prototype,s}const s=new Map;const i=t(class{constructor(t,s,i){this.pageNo=t,this.firstIndex=s,this.timestamp=i,this._id=80}encode(t){return t.uint(80)&&t.uint(this.pageNo)&&t.uint(this.firstIndex)&&t.int(this.timestamp)}});s.set(80,i);const n=t(class{constructor(t){this.timestamp=t,this._id=0}encode(t){return t.uint(0)&&t.uint(this.timestamp)}});s.set(0,n);const e=t(class{constructor(t,s,i){this.url=t,this.referrer=s,this.navigationStart=i,this._id=4}encode(t){return t.uint(4)&&t.string(this.url)&&t.string(this.referrer)&&t.uint(this.navigationStart)}});s.set(4,e);const r=t(class{constructor(t,s){this.width=t,this.height=s,this._id=5}encode(t){return t.uint(5)&&t.uint(this.width)&&t.uint(this.height)}});s.set(5,r);const o=t(class{constructor(t,s){this.x=t,this.y=s,this._id=6}encode(t){return t.uint(6)&&t.int(this.x)&&t.int(this.y)}});s.set(6,o);const h=t(class{constructor(){this._id=7}encode(t){return t.uint(7)}});s.set(7,h);const c=t(class{constructor(t,s,i,n,e){this.id=t,this.parentID=s,this.index=i,this.tag=n,this.svg=e,this._id=8}encode(t){return t.uint(8)&&t.uint(this.id)&&t.uint(this.parentID)&&t.uint(this.index)&&t.string(this.tag)&&t.boolean(this.svg)}});s.set(8,c);const u=t(class{constructor(t,s,i){this.id=t,this.parentID=s,this.index=i,this._id=9}encode(t){return t.uint(9)&&t.uint(this.id)&&t.uint(this.parentID)&&t.uint(this.index)}});s.set(9,u);const a=t(class{constructor(t,s,i){this.id=t,this.parentID=s,this.index=i,this._id=10}encode(t){return t.uint(10)&&t.uint(this.id)&&t.uint(this.parentID)&&t.uint(this.index)}});s.set(10,a);const d=t(class{constructor(t){this.id=t,this._id=11}encode(t){return t.uint(11)&&t.uint(this.id)}});s.set(11,d);const l=t(class{constructor(t,s,i){this.id=t,this.name=s,this.value=i,this._id=12}encode(t){return t.uint(12)&&t.uint(this.id)&&t.string(this.name)&&t.string(this.value)}});s.set(12,l);const g=t(class{constructor(t,s){this.id=t,this.name=s,this._id=13}encode(t){return t.uint(13)&&t.uint(this.id)&&t.string(this.name)}});s.set(13,g);const f=t(class{constructor(t,s){this.id=t,this.data=s,this._id=14}encode(t){return t.uint(14)&&t.uint(this.id)&&t.string(this.data)}});s.set(14,f);const p=t(class{constructor(t,s,i){this.id=t,this.x=s,this.y=i,this._id=16}encode(t){return t.uint(16)&&t.uint(this.id)&&t.int(this.x)&&t.int(this.y)}});s.set(16,p);const m=t(class{constructor(t,s){this.id=t,this.label=s,this._id=17}encode(t){return t.uint(17)&&t.uint(this.id)&&t.string(this.label)}});s.set(17,m);const _=t(class{constructor(t,s,i){this.id=t,this.value=s,this.mask=i,this._id=18}encode(t){return t.uint(18)&&t.uint(this.id)&&t.string(this.value)&&t.int(this.mask)}});s.set(18,_);const y=t(class{constructor(t,s){this.id=t,this.checked=s,this._id=19}encode(t){return t.uint(19)&&t.uint(this.id)&&t.boolean(this.checked)}});s.set(19,y);const v=t(class{constructor(t,s){this.x=t,this.y=s,this._id=20}encode(t){return t.uint(20)&&t.uint(this.x)&&t.uint(this.y)}});s.set(20,v);const S=t(class{constructor(t,s){this.level=t,this.value=s,this._id=22}encode(t){return t.uint(22)&&t.string(this.level)&&t.string(this.value)}});s.set(22,S);const b=t(class{constructor(t,s,i,n,e,r,o,h,c){this.requestStart=t,this.responseStart=s,this.responseEnd=i,this.domContentLoadedEventStart=n,this.domContentLoadedEventEnd=e,this.loadEventStart=r,this.loadEventEnd=o,this.firstPaint=h,this.firstContentfulPaint=c,this._id=23}encode(t){return t.uint(23)&&t.uint(this.requestStart)&&t.uint(this.responseStart)&&t.uint(this.responseEnd)&&t.uint(this.domContentLoadedEventStart)&&t.uint(this.domContentLoadedEventEnd)&&t.uint(this.loadEventStart)&&t.uint(this.loadEventEnd)&&t.uint(this.firstPaint)&&t.uint(this.firstContentfulPaint)}});s.set(23,b);const x=t(class{constructor(t,s,i){this.speedIndex=t,this.visuallyComplete=s,this.timeToInteractive=i,this._id=24}encode(t){return t.uint(24)&&t.uint(this.speedIndex)&&t.uint(this.visuallyComplete)&&t.uint(this.timeToInteractive)}});s.set(24,x);const E=t(class{constructor(t,s,i){this.name=t,this.message=s,this.payload=i,this._id=25}encode(t){return t.uint(25)&&t.string(this.name)&&t.string(this.message)&&t.string(this.payload)}});s.set(25,E);const k=t(class{constructor(t,s){this.name=t,this.payload=s,this._id=27}encode(t){return t.uint(27)&&t.string(this.name)&&t.string(this.payload)}});s.set(27,k);const I=t(class{constructor(t){this.id=t,this._id=28}encode(t){return t.uint(28)&&t.string(this.id)}});s.set(28,I);const z=t(class{constructor(t){this.id=t,this._id=29}encode(t){return t.uint(29)&&t.string(this.id)}});s.set(29,z);const w=t(class{constructor(t,s){this.key=t,this.value=s,this._id=30}encode(t){return t.uint(30)&&t.string(this.key)&&t.string(this.value)}});s.set(30,w);const T=t(class{constructor(t,s,i){this.id=t,this.rule=s,this.index=i,this._id=37}encode(t){return t.uint(37)&&t.uint(this.id)&&t.string(this.rule)&&t.uint(this.index)}});s.set(37,T);const L=t(class{constructor(t,s){this.id=t,this.index=s,this._id=38}encode(t){return t.uint(38)&&t.uint(this.id)&&t.uint(this.index)}});s.set(38,L);const A=t(class{constructor(t,s,i,n,e,r,o){this.method=t,this.url=s,this.request=i,this.response=n,this.status=e,this.timestamp=r,this.duration=o,this._id=39}encode(t){return t.uint(39)&&t.string(this.method)&&t.string(this.url)&&t.string(this.request)&&t.string(this.response)&&t.uint(this.status)&&t.uint(this.timestamp)&&t.uint(this.duration)}});s.set(39,A);const C=t(class{constructor(t,s,i,n){this.name=t,this.duration=s,this.args=i,this.result=n,this._id=40}encode(t){return t.uint(40)&&t.string(this.name)&&t.uint(this.duration)&&t.string(this.args)&&t.string(this.result)}});s.set(40,C);const M=t(class{constructor(t,s){this.key=t,this.value=s,this._id=41}encode(t){return t.uint(41)&&t.string(this.key)&&t.string(this.value)}});s.set(41,M);const R=t(class{constructor(t){this.type=t,this._id=42}encode(t){return t.uint(42)&&t.string(this.type)}});s.set(42,R);const N=t(class{constructor(t,s,i){this.action=t,this.state=s,this.duration=i,this._id=44}encode(t){return t.uint(44)&&t.string(this.action)&&t.string(this.state)&&t.uint(this.duration)}});s.set(44,N);const D=t(class{constructor(t,s){this.mutation=t,this.state=s,this._id=45}encode(t){return t.uint(45)&&t.string(this.mutation)&&t.string(this.state)}});s.set(45,D);const U=t(class{constructor(t,s){this.type=t,this.payload=s,this._id=46}encode(t){return t.uint(46)&&t.string(this.type)&&t.string(this.payload)}});s.set(46,U);const O=t(class{constructor(t,s,i){this.action=t,this.state=s,this.duration=i,this._id=47}encode(t){return t.uint(47)&&t.string(this.action)&&t.string(this.state)&&t.uint(this.duration)}});s.set(47,O);const q=t(class{constructor(t,s,i,n){this.operationKind=t,this.operationName=s,this.variables=i,this.response=n,this._id=48}encode(t){return t.uint(48)&&t.string(this.operationKind)&&t.string(this.operationName)&&t.string(this.variables)&&t.string(this.response)}});s.set(48,q);const H=t(class{constructor(t,s,i,n){this.frames=t,this.ticks=s,this.totalJSHeapSize=i,this.usedJSHeapSize=n,this._id=49}encode(t){return t.uint(49)&&t.int(this.frames)&&t.int(this.ticks)&&t.uint(this.totalJSHeapSize)&&t.uint(this.usedJSHeapSize)}});s.set(49,H);const P=t(class{constructor(t,s,i,n,e,r,o,h){this.timestamp=t,this.duration=s,this.ttfb=i,this.headerSize=n,this.encodedBodySize=e,this.decodedBodySize=r,this.url=o,this.initiator=h,this._id=53}encode(t){return t.uint(53)&&t.uint(this.timestamp)&&t.uint(this.duration)&&t.uint(this.ttfb)&&t.uint(this.headerSize)&&t.uint(this.encodedBodySize)&&t.uint(this.decodedBodySize)&&t.string(this.url)&&t.string(this.initiator)}});s.set(53,P);const B=t(class{constructor(t,s){this.downlink=t,this.type=s,this._id=54}encode(t){return t.uint(54)&&t.uint(this.downlink)&&t.string(this.type)}});s.set(54,B);const J=t(class{constructor(t){this.hidden=t,this._id=55}encode(t){return t.uint(55)&&t.boolean(this.hidden)}});s.set(55,J);const j=t(class{constructor(t,s,i,n,e,r,o){this.timestamp=t,this.duration=s,this.context=i,this.containerType=n,this.containerSrc=e,this.containerId=r,this.containerName=o,this._id=59}encode(t){return t.uint(59)&&t.uint(this.timestamp)&&t.uint(this.duration)&&t.uint(this.context)&&t.uint(this.containerType)&&t.string(this.containerSrc)&&t.string(this.containerId)&&t.string(this.containerName)}});s.set(59,j);const G=t(class{constructor(t,s,i,n){this.id=t,this.name=s,this.value=i,this.baseURL=n,this._id=60}encode(t){return t.uint(60)&&t.uint(this.id)&&t.string(this.name)&&t.string(this.value)&&t.string(this.baseURL)}});s.set(60,G);const K=t(class{constructor(t,s,i){this.id=t,this.data=s,this.baseURL=i,this._id=61}encode(t){return t.uint(61)&&t.uint(this.id)&&t.string(this.data)&&t.string(this.baseURL)}});s.set(61,K);const X=t(class{constructor(t,s){this.type=t,this.value=s,this._id=63}encode(t){return t.uint(63)&&t.string(this.type)&&t.string(this.value)}});s.set(63,X);const F=t(class{constructor(t,s){this.name=t,this.payload=s,this._id=64}encode(t){return t.uint(64)&&t.string(this.name)&&t.string(this.payload)}});s.set(64,F);const Q=t(class{constructor(){this._id=65}encode(t){return t.uint(65)}});s.set(65,Q);const V=t(class{constructor(t,s,i,n){this.id=t,this.rule=s,this.index=i,this.baseURL=n,this._id=67}encode(t){return t.uint(67)&&t.uint(this.id)&&t.string(this.rule)&&t.uint(this.index)&&t.string(this.baseURL)}});s.set(67,V);const W=t(class{constructor(t,s,i,n){this.id=t,this.hesitationTime=s,this.label=i,this.selector=n,this._id=69}encode(t){return t.uint(69)&&t.uint(this.id)&&t.uint(this.hesitationTime)&&t.string(this.label)&&t.string(this.selector)}});s.set(69,W);const Y=t(class{constructor(t,s){this.frameID=t,this.id=s,this._id=70}encode(t){return t.uint(70)&&t.uint(this.frameID)&&t.uint(this.id)}});s.set(70,Y);const Z="function"==typeof TextEncoder?new TextEncoder:{encode(t){const s=t.length,i=new Uint8Array(3*s);let n=-1;for(var e=0,r=0,o=0;o!==s;){if(e=t.charCodeAt(o),o+=1,e>=55296&&e<=56319){if(o===s){i[n+=1]=239,i[n+=1]=191,i[n+=1]=189;break}if(!((r=t.charCodeAt(o))>=56320&&r<=57343)){i[n+=1]=239,i[n+=1]=191,i[n+=1]=189;continue}if(o+=1,(e=1024*(e-55296)+r-56320+65536)>65535){i[n+=1]=240|e>>>18,i[n+=1]=128|e>>>12&63,i[n+=1]=128|e>>>6&63,i[n+=1]=128|63&e;continue}}e<=127?i[n+=1]=0|e:e<=2047?(i[n+=1]=192|e>>>6,i[n+=1]=128|63&e):(i[n+=1]=224|e>>>12,i[n+=1]=128|e>>>6&63,i[n+=1]=128|63&e)}return i.subarray(0,n+1)}};class tt{constructor(t){this.size=t,this.offset=0,this.checkpointOffset=0,this.data=new Uint8Array(t)}checkpoint(){this.checkpointOffset=this.offset}isEmpty(){return 0===this.offset}boolean(t){return this.data[this.offset++]=+t,this.offset<=this.size}uint(t){for((t<0||t>Number.MAX_SAFE_INTEGER)&&(t=0);t>=128;)this.data[this.offset++]=t%256|128,t=Math.floor(t/128);return this.data[this.offset++]=t,this.offset<=this.size}int(t){return t=Math.round(t),this.uint(t>=0?2*t:-2*t-1)}string(t){const s=Z.encode(t),i=s.byteLength;return!(!this.uint(i)||this.offset+i>this.size)&&(this.data.set(s,this.offset),this.offset+=i,!0)}reset(){this.offset=0,this.checkpointOffset=0}flush(){const t=this.data.slice(0,this.checkpointOffset);return this.reset(),t}}let st=1e6,it=2e5,nt=new tt(it),et="",rt="",ot=0,ht=0,ct=0,ut=0,at=!0;function dt(){return new i(ot,ut,ht).encode(nt)}let lt=null;const gt=[];let ft,pt=!1,mt=0,_t=8e3,yt=10;function vt(){if(at||""===rt||""===et)return;const t=nt.flush();pt?gt.push(t):(pt=!0,function t(s){const i=new XMLHttpRequest;i.open("POST",et+"/v1/web/i",!1),i.setRequestHeader("Authorization","Bearer "+rt),i.onreadystatechange=function(){if(4===this.readyState){if(0==this.status)return;if(this.status>=400)return pt=!1,St(),gt.length=0,401===this.status?void self.postMessage("restart"):void self.postMessage(null);const s=gt.shift();s?t(s):pt=!1}},i.onerror=function(i){if(mt>=yt)return St(),void self.postMessage(null);mt++,setTimeout(()=>t(s),_t)},i.send(s.buffer)}(t)),at=!0,dt()}function St(){et="",rt="",null!==lt&&(clearInterval(lt),lt=null),nt.reset()}self.onmessage=({data:t})=>{if(null!==t)return"stop"===t?(vt(),void St()):Array.isArray(t)?void t.forEach(t=>{const i=new(s.get(t._id));if(Object.assign(i,t),i instanceof n?ht=i.timestamp:i instanceof J&&(i.hidden?ft=setTimeout(()=>self.postMessage("restart"),18e5):clearTimeout(ft)),nt.checkpoint(),!i.encode(nt)&&(vt(),!i.encode(nt)))for(;!i.encode(nt);){if(it===st)return console.warn("OpenReplay: beacon size overflow."),nt.reset(),void dt();it=Math.min(2*it,st),nt=new tt(it),dt()}ut++,at=!1}):(et=t.ingestPoint||et,rt=t.token||rt,ot=t.pageNo||ot,ht=t.startTimestamp||ht,ct=t.timeAdjustment||ct,yt=t.connAttemptCount||yt,_t=t.connAttemptGap||_t,st=t.beaconSizeLimit||st,it=Math.min(st,t.beaconSize||it),nt.isEmpty()&&dt(),void(null===lt&&(lt=setInterval(vt,1e4))));vt()};
`], { type: 'text/javascript' })));
            this.worker.onerror = e => {
                this._debug("webworker_error", e);
            };
            this.worker.onmessage = ({ data }) => {
                if (data === null) {
                    this.stop();
                }
                else if (data === "restart") {
                    this.stop();
                    this.start({ forceNew: true });
                }
            };
            const alertWorker = () => {
                if (this.worker) {
                    this.worker.postMessage(null);
                }
            };
            // TODO: keep better tactics, discard others (look https://developer.mozilla.org/en-US/docs/Web/API/Navigator/sendBeacon)
            this.attachEventListener(window, 'beforeunload', alertWorker, false);
            this.attachEventListener(document, 'mouseleave', alertWorker, false, false);
            this.attachEventListener(document, 'visibilitychange', alertWorker, false);
        }
        catch (e) {
            this._debug("worker_start", e);
        }
    }
    _debug(context, e) {
        if (this.options.__debug_report_edp !== null) {
            fetch(this.options.__debug_report_edp, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    context,
                    error: `${e}`
                })
            });
        }
        this.debug.error("OpenReplay error: ", context, e);
    }
    send(message, urgent = false) {
        if (this.activityState === ActivityState.NotActive) {
            return;
        }
        if (this.activityState === ActivityState.Starting) {
            this.preStartMessages.push(message);
        }
        if (this.preStartMessages.length) {
            this.messages.push(...this.preStartMessages);
            this.preStartMessages.length = 0;
        }
        this.messages.push(message);
        if (urgent) {
            this.commit();
        }
    }
    commit() {
        if (this.worker && this.messages.length) {
            this.messages.unshift(new index_js_1.Timestamp((0, utils_js_1.timestamp)()));
            this.worker.postMessage(this.messages);
            this.commitCallbacks.forEach(cb => cb(this.messages));
            this.messages.length = 0;
        }
    }
    safe(fn) {
        const app = this;
        return function (...args) {
            try {
                fn.apply(this, args);
            }
            catch (e) {
                app._debug("safe_fn_call", e);
                // time: timestamp(),
                // name: e.name,
                // message: e.message,
                // stack: e.stack
            }
        }; // TODO: correct typing
    }
    attachCommitCallback(cb) {
        this.commitCallbacks.push(cb);
    }
    attachStartCallback(cb) {
        this.startCallbacks.push(cb);
    }
    attachStopCallback(cb) {
        this.stopCallbacks.push(cb);
    }
    attachEventListener(target, type, listener, useSafe = true, useCapture = true) {
        if (useSafe) {
            listener = this.safe(listener);
        }
        this.attachStartCallback(() => target.addEventListener(type, listener, useCapture));
        this.attachStopCallback(() => target.removeEventListener(type, listener, useCapture));
    }
    checkRequiredVersion(version) {
        const reqVer = version.split('.');
        const ver = this.version.split('.');
        for (let i = 0; i < ver.length; i++) {
            if (Number(ver[i]) < Number(reqVer[i]) || isNaN(Number(ver[i])) || isNaN(Number(reqVer[i]))) {
                return false;
            }
        }
        return true;
    }
    getStartInfo() {
        return {
            userUUID: localStorage.getItem(this.options.local_uuid_key),
            projectKey: this.projectKey,
            revID: this.revID,
            timestamp: (0, utils_js_1.timestamp)(),
            trackerVersion: this.version,
            isSnippet: this.options.__is_snippet,
        };
    }
    getSessionInfo() {
        return Object.assign(Object.assign({}, this.session.getInfo()), this.getStartInfo());
    }
    getSessionToken() {
        const token = sessionStorage.getItem(this.options.session_token_key);
        if (token !== null) {
            return token;
        }
    }
    getSessionID() {
        return this.session.getInfo().sessionID || undefined;
    }
    getHost() {
        return new URL(this.options.ingestPoint).hostname;
    }
    getProjectKey() {
        return this.projectKey;
    }
    getBaseHref() {
        var _a, _b;
        if (typeof this.options.resourceBaseHref === 'string') {
            return this.options.resourceBaseHref;
        }
        else if (typeof this.options.resourceBaseHref === 'object') {
            //switch between  types
        }
        if (document.baseURI) {
            return document.baseURI;
        }
        // IE only
        return ((_b = (_a = document.head) === null || _a === void 0 ? void 0 : _a.getElementsByTagName("base")[0]) === null || _b === void 0 ? void 0 : _b.getAttribute("href")) || location.origin + location.pathname;
    }
    resolveResourceURL(resourceURL) {
        const base = new URL(this.getBaseHref());
        base.pathname += "/" + new URL(resourceURL).pathname;
        base.pathname.replace(/\/+/g, "/");
        return base.toString();
    }
    isServiceURL(url) {
        return url.startsWith(this.options.ingestPoint);
    }
    active() {
        return this.activityState === ActivityState.Active;
    }
    resetNextPageSession(flag) {
        if (flag) {
            sessionStorage.setItem(this.options.session_reset_key, 't');
        }
        else {
            sessionStorage.removeItem(this.options.session_reset_key);
        }
    }
    _start(startOpts) {
        if (!this.worker) {
            return Promise.reject("No worker found: perhaps, CSP is not set.");
        }
        if (this.activityState !== ActivityState.NotActive) {
            return Promise.reject("OpenReplay: trying to call `start()` on the instance that has been started already.");
        }
        this.activityState = ActivityState.Starting;
        let pageNo = 0;
        const pageNoStr = sessionStorage.getItem(this.options.session_pageno_key);
        if (pageNoStr != null) {
            pageNo = parseInt(pageNoStr);
            pageNo++;
        }
        sessionStorage.setItem(this.options.session_pageno_key, pageNo.toString());
        const startInfo = this.getStartInfo();
        const messageData = {
            ingestPoint: this.options.ingestPoint,
            pageNo,
            startTimestamp: startInfo.timestamp,
            connAttemptCount: this.options.connAttemptCount,
            connAttemptGap: this.options.connAttemptGap,
        };
        this.worker.postMessage(messageData); // brings delay of 10th ms?
        const sReset = sessionStorage.getItem(this.options.session_reset_key);
        sessionStorage.removeItem(this.options.session_reset_key);
        return window.fetch(this.options.ingestPoint + '/v1/web/start', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(Object.assign(Object.assign({}, startInfo), { userID: startOpts.userID || this.session.getInfo().userID, token: sessionStorage.getItem(this.options.session_token_key), deviceMemory: performance_js_1.deviceMemory,
                jsHeapSizeLimit: performance_js_1.jsHeapSizeLimit, reset: startOpts.forceNew || sReset !== null })),
        })
            .then(r => {
            if (r.status === 200) {
                return r.json();
            }
            else {
                return r.text().then(text => text === exports.CANCELED
                    ? Promise.reject(exports.CANCELED) // TODO: return {error: CANCELED} instead
                    : Promise.reject(`Server error: ${r.status}. ${text}`));
            }
        })
            .then(r => {
            if (!this.worker) {
                return Promise.reject("no worker found after start request (this might not happen)");
            }
            const { token, userUUID, sessionID, beaconSizeLimit } = r;
            if (typeof token !== 'string' ||
                typeof userUUID !== 'string' ||
                (typeof beaconSizeLimit !== 'number' && typeof beaconSizeLimit !== 'undefined')) {
                return Promise.reject(`Incorrect server response: ${JSON.stringify(r)}`);
            }
            sessionStorage.setItem(this.options.session_token_key, token);
            localStorage.setItem(this.options.local_uuid_key, userUUID);
            this.session.update(Object.assign({ sessionID }, startOpts));
            this.activityState = ActivityState.Active;
            this.worker.postMessage({ token, beaconSizeLimit });
            this.startCallbacks.forEach((cb) => cb());
            this.observer.observe();
            this.ticker.start();
            this.notify.log("OpenReplay tracking started.");
            // TODO: get rid of onStart
            const onStartInfo = { sessionToken: token, userUUID, sessionID };
            if (typeof this.options.onStart === 'function') {
                this.options.onStart(onStartInfo);
            }
            return onStartInfo;
        })
            .catch(reason => {
            sessionStorage.removeItem(this.options.session_token_key);
            this.stop();
            //if (reason === CANCELED) { return Promise.resolve(CANCELED) } // TODO: what to return ????? Throwing is baad
            if (reason !== exports.CANCELED) {
                this.notify.log("OpenReplay was unable to start. ", reason);
                this._debug("session_start", reason);
            }
            return Promise.reject(reason);
        });
    }
    start(options = { forceNew: false }) {
        if (!document.hidden) {
            return this._start(options);
        }
        else {
            return new Promise((resolve) => {
                const onVisibilityChange = () => {
                    if (!document.hidden) {
                        document.removeEventListener("visibilitychange", onVisibilityChange);
                        resolve(this._start(options));
                    }
                };
                document.addEventListener("visibilitychange", onVisibilityChange);
            });
        }
    }
    stop() {
        if (this.activityState !== ActivityState.NotActive) {
            try {
                if (this.worker) {
                    this.worker.postMessage("stop");
                }
                this.sanitizer.clear();
                this.observer.disconnect();
                this.nodes.clear();
                this.ticker.stop();
                this.stopCallbacks.forEach((cb) => cb());
                this.notify.log("OpenReplay tracking stopped.");
            }
            finally {
                this.activityState = ActivityState.NotActive;
            }
        }
    }
}
exports["default"] = App;


/***/ }),

/***/ 44621:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.LogLevel = void 0;
exports.LogLevel = {
    Verbose: 5,
    Log: 4,
    Warnings: 3,
    Errors: 2,
    Silent: 0,
};
function IsCustomLevel(l) {
    return typeof l === 'object';
}
class Logger {
    constructor(options = exports.LogLevel.Silent) {
        this.options = options === true
            ? { level: exports.LogLevel.Verbose }
            : typeof options === "number" ? { level: options } : options;
    }
    log(...args) {
        if (IsCustomLevel(this.options.level)
            ? this.options.level.log
            : this.options.level >= exports.LogLevel.Log) {
            console.log(...args);
        }
    }
    warn(...args) {
        if (IsCustomLevel(this.options.level)
            ? this.options.level.warn
            : this.options.level >= exports.LogLevel.Warnings) {
            console.warn(...args);
        }
    }
    error(...args) {
        if (IsCustomLevel(this.options.level)
            ? this.options.level.error
            : this.options.level >= exports.LogLevel.Errors) {
            console.error(...args);
        }
    }
}
exports["default"] = Logger;


/***/ }),

/***/ 28931:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
class Nodes {
    constructor(node_id) {
        this.node_id = node_id;
        this.nodes = [];
        this.nodeCallbacks = [];
        this.elementListeners = new Map();
    }
    attachNodeCallback(nodeCallback) {
        this.nodeCallbacks.push(nodeCallback);
    }
    attachElementListener(type, node, elementListener) {
        const id = this.getID(node);
        if (id === undefined) {
            return;
        }
        node.addEventListener(type, elementListener);
        let listeners = this.elementListeners.get(id);
        if (listeners === undefined) {
            listeners = [];
            this.elementListeners.set(id, listeners);
            return;
        }
        listeners.push([type, elementListener]);
    }
    registerNode(node) {
        let id = node[this.node_id];
        const isNew = id === undefined;
        if (isNew) {
            id = this.nodes.length;
            this.nodes[id] = node;
            node[this.node_id] = id;
        }
        return [id, isNew];
    }
    unregisterNode(node) {
        const id = node[this.node_id];
        if (id !== undefined) {
            delete node[this.node_id];
            this.nodes[id] = undefined;
            const listeners = this.elementListeners.get(id);
            if (listeners !== undefined) {
                this.elementListeners.delete(id);
                listeners.forEach((listener) => node.removeEventListener(listener[0], listener[1]));
            }
        }
        return id;
    }
    callNodeCallbacks(node) {
        this.nodeCallbacks.forEach((cb) => cb(node));
    }
    getID(node) {
        return node[this.node_id];
    }
    getNode(id) {
        return this.nodes[id];
    }
    clear() {
        for (let id = 0; id < this.nodes.length; id++) {
            const node = this.nodes[id];
            if (node === undefined) {
                continue;
            }
            this.unregisterNode(node);
        }
        this.nodes.length = 0;
    }
}
exports["default"] = Nodes;


/***/ }),

/***/ 5581:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const observer_js_1 = __webpack_require__(92620);
const index_js_1 = __webpack_require__(78067);
class IFrameObserver extends observer_js_1.default {
    observe(iframe) {
        const doc = iframe.contentDocument;
        const hostID = this.app.nodes.getID(iframe);
        if (!doc || hostID === undefined) {
            return;
        } //log TODO common app.logger
        // Have to observe document, because the inner <html> might be changed
        this.observeRoot(doc, (docID) => {
            if (docID === undefined) {
                console.log("OpenReplay: Iframe document not bound");
                return;
            }
            this.app.send((0, index_js_1.CreateIFrameDocument)(hostID, docID));
        });
    }
}
exports["default"] = IFrameObserver;


/***/ }),

/***/ 92620:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const index_js_1 = __webpack_require__(78067);
const context_js_1 = __webpack_require__(12566);
function isSVGElement(node) {
    return node.namespaceURI === 'http://www.w3.org/2000/svg';
}
function isIgnored(node) {
    if ((0, context_js_1.isInstance)(node, Text)) {
        return false;
    }
    if (!(0, context_js_1.isInstance)(node, Element)) {
        return true;
    }
    const tag = node.tagName.toUpperCase();
    if (tag === 'LINK') {
        const rel = node.getAttribute('rel');
        const as = node.getAttribute('as');
        return !((rel === null || rel === void 0 ? void 0 : rel.includes('stylesheet')) || as === "style" || as === "font");
    }
    return (tag === 'SCRIPT' ||
        tag === 'NOSCRIPT' ||
        tag === 'META' ||
        tag === 'TITLE' ||
        tag === 'BASE');
}
function isRootNode(node) {
    return (0, context_js_1.isInstance)(node, Document) || (0, context_js_1.isInstance)(node, ShadowRoot);
}
function isObservable(node) {
    if (isRootNode(node)) {
        return true;
    }
    return !isIgnored(node);
}
class Observer {
    constructor(app, context = window) {
        this.app = app;
        this.context = context;
        this.commited = [];
        this.recents = [];
        this.myNodes = [];
        this.indexes = [];
        this.attributesList = [];
        this.textSet = new Set();
        this.inUpperContext = context.parent === context; //TODO: get rid of context here
        this.observer = new MutationObserver(this.app.safe((mutations) => {
            for (const mutation of mutations) {
                const target = mutation.target;
                const type = mutation.type;
                if (!isObservable(target) || !(0, context_js_1.inDocument)(target)) {
                    continue;
                }
                if (type === 'childList') {
                    for (let i = 0; i < mutation.removedNodes.length; i++) {
                        this.bindTree(mutation.removedNodes[i]);
                    }
                    for (let i = 0; i < mutation.addedNodes.length; i++) {
                        this.bindTree(mutation.addedNodes[i]);
                    }
                    continue;
                }
                const id = this.app.nodes.getID(target);
                if (id === undefined) {
                    continue;
                }
                if (id >= this.recents.length) { // TODO: something more convinient
                    this.recents[id] = undefined;
                }
                if (type === 'attributes') {
                    const name = mutation.attributeName;
                    if (name === null) {
                        continue;
                    }
                    let attr = this.attributesList[id];
                    if (attr === undefined) {
                        this.attributesList[id] = attr = new Set();
                    }
                    attr.add(name);
                    continue;
                }
                if (type === 'characterData') {
                    this.textSet.add(id);
                    continue;
                }
            }
            this.commitNodes();
        }));
    }
    clear() {
        this.commited.length = 0;
        this.recents.length = 0;
        this.indexes.length = 1;
        this.attributesList.length = 0;
        this.textSet.clear();
    }
    sendNodeAttribute(id, node, name, value) {
        if (isSVGElement(node)) {
            if (name.substr(0, 6) === 'xlink:') {
                name = name.substr(6);
            }
            if (value === null) {
                this.app.send(new index_js_1.RemoveNodeAttribute(id, name));
            }
            else if (name === 'href') {
                if (value.length > 1e5) {
                    value = '';
                }
                this.app.send(new index_js_1.SetNodeAttributeURLBased(id, name, value, this.app.getBaseHref()));
            }
            else {
                this.app.send(new index_js_1.SetNodeAttribute(id, name, value));
            }
            return;
        }
        if (name === 'src' ||
            name === 'srcset' ||
            name === 'integrity' ||
            name === 'crossorigin' ||
            name === 'autocomplete' ||
            name.substr(0, 2) === 'on') {
            return;
        }
        if (name === 'value' &&
            (0, context_js_1.isInstance)(node, HTMLInputElement) &&
            node.type !== 'button' &&
            node.type !== 'reset' &&
            node.type !== 'submit') {
            return;
        }
        if (value === null) {
            this.app.send(new index_js_1.RemoveNodeAttribute(id, name));
            return;
        }
        if (name === 'style' || name === 'href' && (0, context_js_1.isInstance)(node, HTMLLinkElement)) {
            this.app.send(new index_js_1.SetNodeAttributeURLBased(id, name, value, this.app.getBaseHref()));
            return;
        }
        if (name === 'href' || value.length > 1e5) {
            value = '';
        }
        this.app.send(new index_js_1.SetNodeAttribute(id, name, value));
    }
    sendNodeData(id, parentElement, data) {
        if ((0, context_js_1.isInstance)(parentElement, HTMLStyleElement) || (0, context_js_1.isInstance)(parentElement, SVGStyleElement)) {
            this.app.send(new index_js_1.SetCSSDataURLBased(id, data, this.app.getBaseHref()));
            return;
        }
        data = this.app.sanitizer.sanitize(id, data);
        this.app.send(new index_js_1.SetNodeData(id, data));
    }
    bindNode(node) {
        const r = this.app.nodes.registerNode(node);
        const id = r[0];
        this.recents[id] = r[1] || this.recents[id] || false;
        this.myNodes[id] = true;
    }
    bindTree(node) {
        if (!isObservable(node)) {
            return;
        }
        this.bindNode(node);
        const walker = document.createTreeWalker(node, NodeFilter.SHOW_ELEMENT + NodeFilter.SHOW_TEXT, {
            acceptNode: (node) => isIgnored(node) || this.app.nodes.getID(node) !== undefined
                ? NodeFilter.FILTER_REJECT
                : NodeFilter.FILTER_ACCEPT,
        }, 
        // @ts-ignore
        false);
        while (walker.nextNode()) {
            this.bindNode(walker.currentNode);
        }
    }
    unbindNode(node) {
        const id = this.app.nodes.unregisterNode(node);
        if (id !== undefined && this.recents[id] === false) {
            this.app.send(new index_js_1.RemoveNode(id));
        }
    }
    _commitNode(id, node) {
        if (isRootNode(node)) {
            return true;
        }
        const parent = node.parentNode;
        let parentID;
        // Disable parent check for the upper context HTMLHtmlElement, because it is root there... (before)
        // TODO: get rid of "special" cases (there is an issue with CreateDocument altered behaviour though)
        // TODO: Clean the logic (though now it workd fine) 
        if (!(0, context_js_1.isInstance)(node, HTMLHtmlElement) || !this.inUpperContext) {
            if (parent === null) {
                this.unbindNode(node);
                return false;
            }
            parentID = this.app.nodes.getID(parent);
            if (parentID === undefined) {
                this.unbindNode(node);
                return false;
            }
            if (!this.commitNode(parentID)) {
                this.unbindNode(node);
                return false;
            }
            this.app.sanitizer.handleNode(id, parentID, node);
        }
        let sibling = node.previousSibling;
        while (sibling !== null) {
            const siblingID = this.app.nodes.getID(sibling);
            if (siblingID !== undefined) {
                this.commitNode(siblingID);
                this.indexes[id] = this.indexes[siblingID] + 1;
                break;
            }
            sibling = sibling.previousSibling;
        }
        if (sibling === null) {
            this.indexes[id] = 0; //
        }
        const isNew = this.recents[id];
        const index = this.indexes[id];
        if (index === undefined) {
            throw 'commitNode: missing node index';
        }
        if (isNew === true) {
            if ((0, context_js_1.isInstance)(node, Element)) {
                if (parentID !== undefined) {
                    this.app.send(new index_js_1.CreateElementNode(id, parentID, index, node.tagName, isSVGElement(node)));
                }
                for (let i = 0; i < node.attributes.length; i++) {
                    const attr = node.attributes[i];
                    this.sendNodeAttribute(id, node, attr.nodeName, attr.value);
                }
            }
            else if ((0, context_js_1.isInstance)(node, Text)) {
                // for text node id != 0, hence parentID !== undefined and parent is Element
                this.app.send(new index_js_1.CreateTextNode(id, parentID, index));
                this.sendNodeData(id, parent, node.data);
            }
            return true;
        }
        if (isNew === false && parentID !== undefined) {
            this.app.send(new index_js_1.MoveNode(id, parentID, index));
        }
        const attr = this.attributesList[id];
        if (attr !== undefined) {
            if (!(0, context_js_1.isInstance)(node, Element)) {
                throw 'commitNode: node is not an element';
            }
            for (const name of attr) {
                this.sendNodeAttribute(id, node, name, node.getAttribute(name));
            }
        }
        if (this.textSet.has(id)) {
            if (!(0, context_js_1.isInstance)(node, Text)) {
                throw 'commitNode: node is not a text';
            }
            // for text node id != 0, hence parent is Element
            this.sendNodeData(id, parent, node.data);
        }
        return true;
    }
    commitNode(id) {
        const node = this.app.nodes.getNode(id);
        if (node === undefined) {
            return false;
        }
        const cmt = this.commited[id];
        if (cmt !== undefined) {
            return cmt;
        }
        return (this.commited[id] = this._commitNode(id, node));
    }
    commitNodes() {
        let node;
        for (let id = 0; id < this.recents.length; id++) {
            // TODO: make things/logic nice here.
            // commit required in any case if recents[id] true or false (in case of unbinding) or undefined (in case of attr change).
            if (!this.myNodes[id]) {
                continue;
            }
            this.commitNode(id);
            if (this.recents[id] === true && (node = this.app.nodes.getNode(id))) {
                this.app.nodes.callNodeCallbacks(node);
            }
        }
        this.clear();
    }
    // ISSSUE
    observeRoot(node, beforeCommit, nodeToBind = node) {
        this.observer.observe(node, {
            childList: true,
            attributes: true,
            characterData: true,
            subtree: true,
            attributeOldValue: false,
            characterDataOldValue: false,
        });
        this.bindTree(nodeToBind);
        beforeCommit(this.app.nodes.getID(node));
        this.commitNodes();
    }
    disconnect() {
        this.observer.disconnect();
        this.clear();
        this.myNodes.length = 0;
    }
}
exports["default"] = Observer;


/***/ }),

/***/ 9399:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const observer_js_1 = __webpack_require__(92620);
const index_js_1 = __webpack_require__(78067);
class ShadowRootObserver extends observer_js_1.default {
    observe(el) {
        const shRoot = el.shadowRoot;
        const hostID = this.app.nodes.getID(el);
        if (!shRoot || hostID === undefined) {
            return;
        } // log
        this.observeRoot(shRoot, (rootID) => {
            if (rootID === undefined) {
                console.log("OpenReplay: Shadow Root was not bound");
                return;
            }
            this.app.send((0, index_js_1.CreateIFrameDocument)(hostID, rootID));
        });
    }
}
exports["default"] = ShadowRootObserver;


/***/ }),

/***/ 29012:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const observer_js_1 = __webpack_require__(92620);
const context_js_1 = __webpack_require__(12566);
const iframe_observer_js_1 = __webpack_require__(5581);
const shadow_root_observer_js_1 = __webpack_require__(9399);
const index_js_1 = __webpack_require__(78067);
const utils_js_1 = __webpack_require__(80901);
const attachShadowNativeFn = utils_js_1.IN_BROWSER ? Element.prototype.attachShadow : () => new ShadowRoot();
class TopObserver extends observer_js_1.default {
    constructor(app, options) {
        super(app);
        this.iframeObservers = [];
        this.shadowRootObservers = [];
        this.options = Object.assign({
            captureIFrames: false
        }, options);
        // IFrames
        this.app.nodes.attachNodeCallback(node => {
            if ((0, context_js_1.isInstance)(node, HTMLIFrameElement) &&
                (this.options.captureIFrames || node.getAttribute("data-openreplay-capture"))) {
                this.handleIframe(node);
            }
        });
        // ShadowDOM
        this.app.nodes.attachNodeCallback(node => {
            if ((0, context_js_1.isInstance)(node, Element) && node.shadowRoot !== null) {
                this.handleShadowRoot(node.shadowRoot);
            }
        });
    }
    handleIframe(iframe) {
        let context = null;
        const handle = this.app.safe(() => {
            const id = this.app.nodes.getID(iframe);
            if (id === undefined) {
                return;
            } //log
            if (iframe.contentWindow === context) {
                return;
            } //Does this happen frequently?
            context = iframe.contentWindow;
            if (!context) {
                return;
            }
            const observer = new iframe_observer_js_1.default(this.app, context);
            this.iframeObservers.push(observer);
            observer.observe(iframe);
        });
        this.app.attachEventListener(iframe, "load", handle);
        handle();
    }
    handleShadowRoot(shRoot) {
        const observer = new shadow_root_observer_js_1.default(this.app, this.context);
        this.shadowRootObservers.push(observer);
        observer.observe(shRoot.host);
    }
    observe() {
        // Protection from several subsequent calls?
        const observer = this;
        Element.prototype.attachShadow = function () {
            const shadow = attachShadowNativeFn.apply(this, arguments);
            observer.handleShadowRoot(shadow);
            return shadow;
        };
        // Can observe documentElement (<html>) here, because it is not supposed to be changing.
        // However, it is possible in some exotic cases and may cause an ignorance of the newly created <html>
        // In this case context.document have to be observed, but this will cause 
        // the change in the re-player behaviour caused by CreateDocument message: 
        //   the 0-node ("fRoot") will become #document rather than documentElement as it is now.
        // Alternatively - observe(#document) then bindNode(documentElement)
        this.observeRoot(this.context.document, () => {
            this.app.send(new index_js_1.CreateDocument());
        }, this.context.document.documentElement);
    }
    disconnect() {
        Element.prototype.attachShadow = attachShadowNativeFn;
        this.iframeObservers.forEach(o => o.disconnect());
        this.iframeObservers = [];
        this.shadowRootObservers.forEach(o => o.disconnect());
        this.shadowRootObservers = [];
        super.disconnect();
    }
}
exports["default"] = TopObserver;


/***/ }),

/***/ 45793:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const utils_js_1 = __webpack_require__(80901);
const context_js_1 = __webpack_require__(12566);
class Sanitizer {
    constructor(app, options) {
        this.app = app;
        this.masked = new Set();
        this.options = Object.assign({
            obscureTextEmails: true,
            obscureTextNumbers: false,
        }, options);
    }
    handleNode(id, parentID, node) {
        if (this.masked.has(parentID) ||
            ((0, context_js_1.isInstance)(node, Element) && (0, utils_js_1.hasOpenreplayAttribute)(node, 'masked'))) {
            this.masked.add(id);
        }
    }
    sanitize(id, data) {
        if (this.masked.has(id)) {
            // TODO: is it the best place to put trim() ? Might trimmed spaces be considered in layout in certain cases?
            return data.trim().replace(/[^\f\n\r\t\v\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]/g, '█');
        }
        if (this.options.obscureTextNumbers) {
            data = data.replace(/\d/g, '0');
        }
        if (this.options.obscureTextEmails) {
            data = data.replace(/([^\s]+)@([^\s]+)\.([^\s]+)/g, (...f) => (0, utils_js_1.stars)(f[1]) + '@' + (0, utils_js_1.stars)(f[2]) + '.' + (0, utils_js_1.stars)(f[3]));
        }
        return data;
    }
    isMasked(id) {
        return this.masked.has(id);
    }
    getInnerTextSecure(el) {
        const id = this.app.nodes.getID(el);
        if (!id) {
            return '';
        }
        return this.sanitize(id, el.innerText);
    }
    clear() {
        this.masked.clear();
    }
}
exports["default"] = Sanitizer;


/***/ }),

/***/ 64138:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const index_js_1 = __webpack_require__(78067);
var ActivityState;
(function (ActivityState) {
    ActivityState[ActivityState["NotActive"] = 0] = "NotActive";
    ActivityState[ActivityState["Starting"] = 1] = "Starting";
    ActivityState[ActivityState["Active"] = 2] = "Active";
})(ActivityState || (ActivityState = {}));
class Session {
    constructor(app) {
        this.app = app;
        this.metadata = {};
        this.userID = null;
        this.sessionID = null;
        this.activityState = ActivityState.NotActive;
        this.callbacks = [];
    }
    attachUpdateCallback(cb) {
        this.callbacks.push(cb);
    }
    handleUpdate() {
        const sessInfo = this.getInfo();
        if (sessInfo.userID == null) {
            delete sessInfo.userID;
        }
        if (sessInfo.sessionID == null) {
            delete sessInfo.sessionID;
        }
        this.callbacks.forEach(cb => cb(sessInfo));
    }
    update({ userID, metadata, sessionID }) {
        if (userID != null) { // TODO clear nullable/undefinable types
            this._setUserID(userID);
        }
        if (metadata !== undefined) {
            Object.entries(metadata).forEach(kv => this._setMetadata(...kv));
        }
        if (sessionID !== undefined) {
            this.sessionID = sessionID;
        }
        this.handleUpdate();
    }
    _setMetadata(key, value) {
        this.app.send(new index_js_1.Metadata(key, value));
        this.metadata[key] = value;
    }
    _setUserID(userID) {
        this.app.send(new index_js_1.UserID(userID));
        this.userID = userID;
    }
    setMetadata(key, value) {
        this._setMetadata(key, value);
        this.handleUpdate();
    }
    setUserID(userID) {
        this._setUserID(userID);
        this.handleUpdate();
    }
    getInfo() {
        return {
            sessionID: this.sessionID,
            metadata: this.metadata,
            userID: this.userID,
        };
    }
}
exports["default"] = Session;


/***/ }),

/***/ 55857:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
function wrap(callback, n) {
    let t = 0;
    return () => {
        if (t++ >= n) {
            t = 0;
            callback();
        }
    };
}
class Ticker {
    constructor(app) {
        this.app = app;
        this.timer = null;
        this.callbacks = [];
    }
    attach(callback, n = 0, useSafe = true, thisArg) {
        if (thisArg) {
            callback = callback.bind(thisArg);
        }
        if (useSafe) {
            callback = this.app.safe(callback);
        }
        this.callbacks.unshift(n ? wrap(callback, n) : callback) - 1;
    }
    start() {
        if (this.timer === null) {
            this.timer = setInterval(() => this.callbacks.forEach((cb) => {
                if (cb)
                    cb();
            }), 30);
        }
    }
    stop() {
        if (this.timer !== null) {
            clearInterval(this.timer);
            this.timer = null;
        }
    }
}
exports["default"] = Ticker;


/***/ }),

/***/ 48826:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Messages = exports.App = void 0;
const index_js_1 = __webpack_require__(89441);
var index_js_2 = __webpack_require__(89441);
Object.defineProperty(exports, "App", ({ enumerable: true, get: function () { return index_js_2.default; } }));
const index_js_3 = __webpack_require__(78067);
const _Messages = __webpack_require__(78067);
exports.Messages = _Messages;
const connection_js_1 = __webpack_require__(32042);
const console_js_1 = __webpack_require__(21217);
const exception_js_1 = __webpack_require__(76978);
const img_js_1 = __webpack_require__(72107);
const input_js_1 = __webpack_require__(34134);
const mouse_js_1 = __webpack_require__(21495);
const timing_js_1 = __webpack_require__(48342);
const performance_js_1 = __webpack_require__(86033);
const scroll_js_1 = __webpack_require__(20185);
const viewport_js_1 = __webpack_require__(46310);
const cssrules_js_1 = __webpack_require__(14312);
const utils_js_1 = __webpack_require__(80901);
const DOCS_SETUP = '/installation/setup-or';
function processOptions(obj) {
    if (obj == null) {
        console.error(`OpenReplay: invalid options argument type. Please, check documentation on ${utils_js_1.DOCS_HOST}${DOCS_SETUP}`);
        return false;
    }
    if (typeof obj.projectKey !== 'string') {
        if (typeof obj.projectKey !== 'number') {
            if (typeof obj.projectID !== 'number') { // Back compatability
                console.error(`OpenReplay: projectKey is missing or wrong type (string is expected). Please, check ${utils_js_1.DOCS_HOST}${DOCS_SETUP} for more information.`);
                return false;
            }
            else {
                obj.projectKey = obj.projectID.toString();
                (0, utils_js_1.deprecationWarn)("`projectID` option", "`projectKey` option", DOCS_SETUP);
            }
        }
        else {
            console.warn("OpenReplay: projectKey is expected to have a string type.");
            obj.projectKey = obj.projectKey.toString();
        }
    }
    if (typeof obj.sessionToken !== 'string' && obj.sessionToken != null) {
        console.warn(`OpenReplay: invalid options argument type. Please, check documentation on ${utils_js_1.DOCS_HOST}${DOCS_SETUP}`);
    }
    return true;
}
class API {
    constructor(options) {
        this.options = options;
        this.app = null;
        this.handleError = (e) => {
            if (this.app === null) {
                return;
            }
            if (e instanceof Error) {
                this.app.send((0, exception_js_1.getExceptionMessage)(e, []));
            }
            else if (e instanceof ErrorEvent ||
                ('PromiseRejectionEvent' in window && e instanceof PromiseRejectionEvent)) {
                const msg = (0, exception_js_1.getExceptionMessageFromEvent)(e);
                if (msg != null) {
                    this.app.send(msg);
                }
            }
        };
        if (!utils_js_1.IN_BROWSER || !processOptions(options)) {
            return;
        }
        if (window.__OPENREPLAY__) {
            console.error("OpenReplay: one tracker instance has been initialised already");
            return;
        }
        if (!options.__DISABLE_SECURE_MODE && location.protocol !== 'https:') {
            console.error("OpenReplay: Your website must be publicly accessible and running on SSL in order for OpenReplay to properly capture and replay the user session. You can disable this check by setting `__DISABLE_SECURE_MODE` option to `true` if you are testing in localhost. Keep in mind, that asset files on a local machine are not available to the outside world. This might affect tracking if you use css files.");
            return;
        }
        const doNotTrack = options.respectDoNotTrack &&
            (navigator.doNotTrack == '1'
                // @ts-ignore
                || window.doNotTrack == '1');
        const app = this.app = doNotTrack ||
            !('Map' in window) ||
            !('Set' in window) ||
            !('MutationObserver' in window) ||
            !('performance' in window) ||
            !('timing' in performance) ||
            !('startsWith' in String.prototype) ||
            !('Blob' in window) ||
            !('Worker' in window)
            ? null
            : new index_js_1.default(options.projectKey, options.sessionToken, options);
        if (app !== null) {
            (0, viewport_js_1.default)(app);
            (0, cssrules_js_1.default)(app);
            (0, connection_js_1.default)(app);
            (0, console_js_1.default)(app, options);
            (0, exception_js_1.default)(app, options);
            (0, img_js_1.default)(app);
            (0, input_js_1.default)(app, options);
            (0, mouse_js_1.default)(app);
            (0, timing_js_1.default)(app, options);
            (0, performance_js_1.default)(app, options);
            (0, scroll_js_1.default)(app);
            window.__OPENREPLAY__ = this;
            if (options.autoResetOnWindowOpen) {
                const wOpen = window.open;
                app.attachStartCallback(() => {
                    // @ts-ignore ?
                    window.open = function (...args) {
                        app.resetNextPageSession(true);
                        wOpen.call(window, ...args);
                        app.resetNextPageSession(false);
                    };
                });
                app.attachStopCallback(() => {
                    window.open = wOpen;
                });
            }
        }
        else {
            console.log("OpenReplay: browser doesn't support API required for tracking or doNotTrack is set to 1.");
            const req = new XMLHttpRequest();
            const orig = options.ingestPoint || index_js_1.DEFAULT_INGEST_POINT;
            req.open("POST", orig + "/v1/web/not-started");
            // no-cors issue only with text/plain or not-set Content-Type
            // req.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
            req.send(JSON.stringify({
                trackerVersion: '3.5.3',
                projectKey: options.projectKey,
                doNotTrack,
                // TODO: add precise reason (an exact API missing)
            }));
        }
    }
    use(fn) {
        return fn(this.app, this.options);
    }
    isActive() {
        if (this.app === null) {
            return false;
        }
        return this.app.active();
    }
    start(startOpts) {
        if (!utils_js_1.IN_BROWSER) {
            console.error(`OpenReplay: you are trying to start Tracker on a node.js environment. If you want to use OpenReplay with SSR, please, use componentDidMount or useEffect API for placing the \`tracker.start()\` line. Check documentation on ${utils_js_1.DOCS_HOST}${DOCS_SETUP}`);
            return Promise.reject("Trying to start not in browser.");
        }
        if (this.app === null) {
            return Promise.reject("Browser doesn't support required api, or doNotTrack is active.");
        }
        // TODO: check argument typing
        return this.app.start(startOpts);
    }
    stop() {
        if (this.app === null) {
            return;
        }
        this.app.stop();
    }
    getSessionToken() {
        if (this.app === null) {
            return null;
        }
        return this.app.getSessionToken();
    }
    getSessionID() {
        if (this.app === null) {
            return null;
        }
        return this.app.getSessionID();
    }
    sessionID() {
        (0, utils_js_1.deprecationWarn)("'sessionID' method", "'getSessionID' method", "/");
        return this.getSessionID();
    }
    setUserID(id) {
        if (typeof id === 'string' && this.app !== null) {
            this.app.session.setUserID(id);
        }
    }
    userID(id) {
        (0, utils_js_1.deprecationWarn)("'userID' method", "'setUserID' method", "/");
        this.setUserID(id);
    }
    setUserAnonymousID(id) {
        if (typeof id === 'string' && this.app !== null) {
            this.app.send(new index_js_3.UserAnonymousID(id));
        }
    }
    userAnonymousID(id) {
        (0, utils_js_1.deprecationWarn)("'userAnonymousID' method", "'setUserAnonymousID' method", "/");
        this.setUserAnonymousID(id);
    }
    setMetadata(key, value) {
        if (typeof key === 'string' &&
            typeof value === 'string' &&
            this.app !== null) {
            this.app.session.setMetadata(key, value);
        }
    }
    metadata(key, value) {
        (0, utils_js_1.deprecationWarn)("'metadata' method", "'setMetadata' method", "/");
        this.setMetadata(key, value);
    }
    event(key, payload, issue = false) {
        if (typeof key === 'string' && this.app !== null) {
            if (issue) {
                return this.issue(key, payload);
            }
            else {
                try {
                    payload = JSON.stringify(payload);
                }
                catch (e) {
                    return;
                }
                this.app.send(new index_js_3.RawCustomEvent(key, payload));
            }
        }
    }
    issue(key, payload) {
        if (typeof key === 'string' && this.app !== null) {
            try {
                payload = JSON.stringify(payload);
            }
            catch (e) {
                return;
            }
            this.app.send(new index_js_3.CustomIssue(key, payload));
        }
    }
}
exports["default"] = API;


/***/ }),

/***/ 78067:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MouseClick = exports.CSSInsertRuleURLBased = exports.PageClose = exports.CustomIssue = exports.TechnicalInfo = exports.SetCSSDataURLBased = exports.SetNodeAttributeURLBased = exports.LongTask = exports.SetPageVisibility = exports.ConnectionInformation = exports.ResourceTiming = exports.PerformanceTrack = exports.GraphQL = exports.NgRx = exports.MobX = exports.Vuex = exports.Redux = exports.StateAction = exports.OTable = exports.Profiler = exports.Fetch = exports.CSSDeleteRule = exports.CSSInsertRule = exports.Metadata = exports.UserAnonymousID = exports.UserID = exports.RawCustomEvent = exports.JSException = exports.PageRenderTiming = exports.PageLoadTiming = exports.ConsoleLog = exports.MouseMove = exports.SetInputChecked = exports.SetInputValue = exports.SetInputTarget = exports.SetNodeScroll = exports.SetNodeData = exports.RemoveNodeAttribute = exports.SetNodeAttribute = exports.RemoveNode = exports.MoveNode = exports.CreateTextNode = exports.CreateElementNode = exports.CreateDocument = exports.SetViewportScroll = exports.SetViewportSize = exports.SetPageLocation = exports.Timestamp = exports.BatchMeta = exports.classes = void 0;
exports.CreateIFrameDocument = void 0;
function bindNew(Class) {
    function _Class(...args) {
        return new Class(...args);
    }
    _Class.prototype = Class.prototype;
    return _Class;
}
exports.classes = new Map();
class _BatchMeta {
    constructor(pageNo, firstIndex, timestamp) {
        this.pageNo = pageNo;
        this.firstIndex = firstIndex;
        this.timestamp = timestamp;
        this._id = 80;
    }
    encode(writer) {
        return writer.uint(80) &&
            writer.uint(this.pageNo) &&
            writer.uint(this.firstIndex) &&
            writer.int(this.timestamp);
    }
}
exports.BatchMeta = bindNew(_BatchMeta);
exports.classes.set(80, exports.BatchMeta);
class _Timestamp {
    constructor(timestamp) {
        this.timestamp = timestamp;
        this._id = 0;
    }
    encode(writer) {
        return writer.uint(0) &&
            writer.uint(this.timestamp);
    }
}
exports.Timestamp = bindNew(_Timestamp);
exports.classes.set(0, exports.Timestamp);
class _SetPageLocation {
    constructor(url, referrer, navigationStart) {
        this.url = url;
        this.referrer = referrer;
        this.navigationStart = navigationStart;
        this._id = 4;
    }
    encode(writer) {
        return writer.uint(4) &&
            writer.string(this.url) &&
            writer.string(this.referrer) &&
            writer.uint(this.navigationStart);
    }
}
exports.SetPageLocation = bindNew(_SetPageLocation);
exports.classes.set(4, exports.SetPageLocation);
class _SetViewportSize {
    constructor(width, height) {
        this.width = width;
        this.height = height;
        this._id = 5;
    }
    encode(writer) {
        return writer.uint(5) &&
            writer.uint(this.width) &&
            writer.uint(this.height);
    }
}
exports.SetViewportSize = bindNew(_SetViewportSize);
exports.classes.set(5, exports.SetViewportSize);
class _SetViewportScroll {
    constructor(x, y) {
        this.x = x;
        this.y = y;
        this._id = 6;
    }
    encode(writer) {
        return writer.uint(6) &&
            writer.int(this.x) &&
            writer.int(this.y);
    }
}
exports.SetViewportScroll = bindNew(_SetViewportScroll);
exports.classes.set(6, exports.SetViewportScroll);
class _CreateDocument {
    constructor() {
        this._id = 7;
    }
    encode(writer) {
        return writer.uint(7);
    }
}
exports.CreateDocument = bindNew(_CreateDocument);
exports.classes.set(7, exports.CreateDocument);
class _CreateElementNode {
    constructor(id, parentID, index, tag, svg) {
        this.id = id;
        this.parentID = parentID;
        this.index = index;
        this.tag = tag;
        this.svg = svg;
        this._id = 8;
    }
    encode(writer) {
        return writer.uint(8) &&
            writer.uint(this.id) &&
            writer.uint(this.parentID) &&
            writer.uint(this.index) &&
            writer.string(this.tag) &&
            writer.boolean(this.svg);
    }
}
exports.CreateElementNode = bindNew(_CreateElementNode);
exports.classes.set(8, exports.CreateElementNode);
class _CreateTextNode {
    constructor(id, parentID, index) {
        this.id = id;
        this.parentID = parentID;
        this.index = index;
        this._id = 9;
    }
    encode(writer) {
        return writer.uint(9) &&
            writer.uint(this.id) &&
            writer.uint(this.parentID) &&
            writer.uint(this.index);
    }
}
exports.CreateTextNode = bindNew(_CreateTextNode);
exports.classes.set(9, exports.CreateTextNode);
class _MoveNode {
    constructor(id, parentID, index) {
        this.id = id;
        this.parentID = parentID;
        this.index = index;
        this._id = 10;
    }
    encode(writer) {
        return writer.uint(10) &&
            writer.uint(this.id) &&
            writer.uint(this.parentID) &&
            writer.uint(this.index);
    }
}
exports.MoveNode = bindNew(_MoveNode);
exports.classes.set(10, exports.MoveNode);
class _RemoveNode {
    constructor(id) {
        this.id = id;
        this._id = 11;
    }
    encode(writer) {
        return writer.uint(11) &&
            writer.uint(this.id);
    }
}
exports.RemoveNode = bindNew(_RemoveNode);
exports.classes.set(11, exports.RemoveNode);
class _SetNodeAttribute {
    constructor(id, name, value) {
        this.id = id;
        this.name = name;
        this.value = value;
        this._id = 12;
    }
    encode(writer) {
        return writer.uint(12) &&
            writer.uint(this.id) &&
            writer.string(this.name) &&
            writer.string(this.value);
    }
}
exports.SetNodeAttribute = bindNew(_SetNodeAttribute);
exports.classes.set(12, exports.SetNodeAttribute);
class _RemoveNodeAttribute {
    constructor(id, name) {
        this.id = id;
        this.name = name;
        this._id = 13;
    }
    encode(writer) {
        return writer.uint(13) &&
            writer.uint(this.id) &&
            writer.string(this.name);
    }
}
exports.RemoveNodeAttribute = bindNew(_RemoveNodeAttribute);
exports.classes.set(13, exports.RemoveNodeAttribute);
class _SetNodeData {
    constructor(id, data) {
        this.id = id;
        this.data = data;
        this._id = 14;
    }
    encode(writer) {
        return writer.uint(14) &&
            writer.uint(this.id) &&
            writer.string(this.data);
    }
}
exports.SetNodeData = bindNew(_SetNodeData);
exports.classes.set(14, exports.SetNodeData);
class _SetNodeScroll {
    constructor(id, x, y) {
        this.id = id;
        this.x = x;
        this.y = y;
        this._id = 16;
    }
    encode(writer) {
        return writer.uint(16) &&
            writer.uint(this.id) &&
            writer.int(this.x) &&
            writer.int(this.y);
    }
}
exports.SetNodeScroll = bindNew(_SetNodeScroll);
exports.classes.set(16, exports.SetNodeScroll);
class _SetInputTarget {
    constructor(id, label) {
        this.id = id;
        this.label = label;
        this._id = 17;
    }
    encode(writer) {
        return writer.uint(17) &&
            writer.uint(this.id) &&
            writer.string(this.label);
    }
}
exports.SetInputTarget = bindNew(_SetInputTarget);
exports.classes.set(17, exports.SetInputTarget);
class _SetInputValue {
    constructor(id, value, mask) {
        this.id = id;
        this.value = value;
        this.mask = mask;
        this._id = 18;
    }
    encode(writer) {
        return writer.uint(18) &&
            writer.uint(this.id) &&
            writer.string(this.value) &&
            writer.int(this.mask);
    }
}
exports.SetInputValue = bindNew(_SetInputValue);
exports.classes.set(18, exports.SetInputValue);
class _SetInputChecked {
    constructor(id, checked) {
        this.id = id;
        this.checked = checked;
        this._id = 19;
    }
    encode(writer) {
        return writer.uint(19) &&
            writer.uint(this.id) &&
            writer.boolean(this.checked);
    }
}
exports.SetInputChecked = bindNew(_SetInputChecked);
exports.classes.set(19, exports.SetInputChecked);
class _MouseMove {
    constructor(x, y) {
        this.x = x;
        this.y = y;
        this._id = 20;
    }
    encode(writer) {
        return writer.uint(20) &&
            writer.uint(this.x) &&
            writer.uint(this.y);
    }
}
exports.MouseMove = bindNew(_MouseMove);
exports.classes.set(20, exports.MouseMove);
class _ConsoleLog {
    constructor(level, value) {
        this.level = level;
        this.value = value;
        this._id = 22;
    }
    encode(writer) {
        return writer.uint(22) &&
            writer.string(this.level) &&
            writer.string(this.value);
    }
}
exports.ConsoleLog = bindNew(_ConsoleLog);
exports.classes.set(22, exports.ConsoleLog);
class _PageLoadTiming {
    constructor(requestStart, responseStart, responseEnd, domContentLoadedEventStart, domContentLoadedEventEnd, loadEventStart, loadEventEnd, firstPaint, firstContentfulPaint) {
        this.requestStart = requestStart;
        this.responseStart = responseStart;
        this.responseEnd = responseEnd;
        this.domContentLoadedEventStart = domContentLoadedEventStart;
        this.domContentLoadedEventEnd = domContentLoadedEventEnd;
        this.loadEventStart = loadEventStart;
        this.loadEventEnd = loadEventEnd;
        this.firstPaint = firstPaint;
        this.firstContentfulPaint = firstContentfulPaint;
        this._id = 23;
    }
    encode(writer) {
        return writer.uint(23) &&
            writer.uint(this.requestStart) &&
            writer.uint(this.responseStart) &&
            writer.uint(this.responseEnd) &&
            writer.uint(this.domContentLoadedEventStart) &&
            writer.uint(this.domContentLoadedEventEnd) &&
            writer.uint(this.loadEventStart) &&
            writer.uint(this.loadEventEnd) &&
            writer.uint(this.firstPaint) &&
            writer.uint(this.firstContentfulPaint);
    }
}
exports.PageLoadTiming = bindNew(_PageLoadTiming);
exports.classes.set(23, exports.PageLoadTiming);
class _PageRenderTiming {
    constructor(speedIndex, visuallyComplete, timeToInteractive) {
        this.speedIndex = speedIndex;
        this.visuallyComplete = visuallyComplete;
        this.timeToInteractive = timeToInteractive;
        this._id = 24;
    }
    encode(writer) {
        return writer.uint(24) &&
            writer.uint(this.speedIndex) &&
            writer.uint(this.visuallyComplete) &&
            writer.uint(this.timeToInteractive);
    }
}
exports.PageRenderTiming = bindNew(_PageRenderTiming);
exports.classes.set(24, exports.PageRenderTiming);
class _JSException {
    constructor(name, message, payload) {
        this.name = name;
        this.message = message;
        this.payload = payload;
        this._id = 25;
    }
    encode(writer) {
        return writer.uint(25) &&
            writer.string(this.name) &&
            writer.string(this.message) &&
            writer.string(this.payload);
    }
}
exports.JSException = bindNew(_JSException);
exports.classes.set(25, exports.JSException);
class _RawCustomEvent {
    constructor(name, payload) {
        this.name = name;
        this.payload = payload;
        this._id = 27;
    }
    encode(writer) {
        return writer.uint(27) &&
            writer.string(this.name) &&
            writer.string(this.payload);
    }
}
exports.RawCustomEvent = bindNew(_RawCustomEvent);
exports.classes.set(27, exports.RawCustomEvent);
class _UserID {
    constructor(id) {
        this.id = id;
        this._id = 28;
    }
    encode(writer) {
        return writer.uint(28) &&
            writer.string(this.id);
    }
}
exports.UserID = bindNew(_UserID);
exports.classes.set(28, exports.UserID);
class _UserAnonymousID {
    constructor(id) {
        this.id = id;
        this._id = 29;
    }
    encode(writer) {
        return writer.uint(29) &&
            writer.string(this.id);
    }
}
exports.UserAnonymousID = bindNew(_UserAnonymousID);
exports.classes.set(29, exports.UserAnonymousID);
class _Metadata {
    constructor(key, value) {
        this.key = key;
        this.value = value;
        this._id = 30;
    }
    encode(writer) {
        return writer.uint(30) &&
            writer.string(this.key) &&
            writer.string(this.value);
    }
}
exports.Metadata = bindNew(_Metadata);
exports.classes.set(30, exports.Metadata);
class _CSSInsertRule {
    constructor(id, rule, index) {
        this.id = id;
        this.rule = rule;
        this.index = index;
        this._id = 37;
    }
    encode(writer) {
        return writer.uint(37) &&
            writer.uint(this.id) &&
            writer.string(this.rule) &&
            writer.uint(this.index);
    }
}
exports.CSSInsertRule = bindNew(_CSSInsertRule);
exports.classes.set(37, exports.CSSInsertRule);
class _CSSDeleteRule {
    constructor(id, index) {
        this.id = id;
        this.index = index;
        this._id = 38;
    }
    encode(writer) {
        return writer.uint(38) &&
            writer.uint(this.id) &&
            writer.uint(this.index);
    }
}
exports.CSSDeleteRule = bindNew(_CSSDeleteRule);
exports.classes.set(38, exports.CSSDeleteRule);
class _Fetch {
    constructor(method, url, request, response, status, timestamp, duration) {
        this.method = method;
        this.url = url;
        this.request = request;
        this.response = response;
        this.status = status;
        this.timestamp = timestamp;
        this.duration = duration;
        this._id = 39;
    }
    encode(writer) {
        return writer.uint(39) &&
            writer.string(this.method) &&
            writer.string(this.url) &&
            writer.string(this.request) &&
            writer.string(this.response) &&
            writer.uint(this.status) &&
            writer.uint(this.timestamp) &&
            writer.uint(this.duration);
    }
}
exports.Fetch = bindNew(_Fetch);
exports.classes.set(39, exports.Fetch);
class _Profiler {
    constructor(name, duration, args, result) {
        this.name = name;
        this.duration = duration;
        this.args = args;
        this.result = result;
        this._id = 40;
    }
    encode(writer) {
        return writer.uint(40) &&
            writer.string(this.name) &&
            writer.uint(this.duration) &&
            writer.string(this.args) &&
            writer.string(this.result);
    }
}
exports.Profiler = bindNew(_Profiler);
exports.classes.set(40, exports.Profiler);
class _OTable {
    constructor(key, value) {
        this.key = key;
        this.value = value;
        this._id = 41;
    }
    encode(writer) {
        return writer.uint(41) &&
            writer.string(this.key) &&
            writer.string(this.value);
    }
}
exports.OTable = bindNew(_OTable);
exports.classes.set(41, exports.OTable);
class _StateAction {
    constructor(type) {
        this.type = type;
        this._id = 42;
    }
    encode(writer) {
        return writer.uint(42) &&
            writer.string(this.type);
    }
}
exports.StateAction = bindNew(_StateAction);
exports.classes.set(42, exports.StateAction);
class _Redux {
    constructor(action, state, duration) {
        this.action = action;
        this.state = state;
        this.duration = duration;
        this._id = 44;
    }
    encode(writer) {
        return writer.uint(44) &&
            writer.string(this.action) &&
            writer.string(this.state) &&
            writer.uint(this.duration);
    }
}
exports.Redux = bindNew(_Redux);
exports.classes.set(44, exports.Redux);
class _Vuex {
    constructor(mutation, state) {
        this.mutation = mutation;
        this.state = state;
        this._id = 45;
    }
    encode(writer) {
        return writer.uint(45) &&
            writer.string(this.mutation) &&
            writer.string(this.state);
    }
}
exports.Vuex = bindNew(_Vuex);
exports.classes.set(45, exports.Vuex);
class _MobX {
    constructor(type, payload) {
        this.type = type;
        this.payload = payload;
        this._id = 46;
    }
    encode(writer) {
        return writer.uint(46) &&
            writer.string(this.type) &&
            writer.string(this.payload);
    }
}
exports.MobX = bindNew(_MobX);
exports.classes.set(46, exports.MobX);
class _NgRx {
    constructor(action, state, duration) {
        this.action = action;
        this.state = state;
        this.duration = duration;
        this._id = 47;
    }
    encode(writer) {
        return writer.uint(47) &&
            writer.string(this.action) &&
            writer.string(this.state) &&
            writer.uint(this.duration);
    }
}
exports.NgRx = bindNew(_NgRx);
exports.classes.set(47, exports.NgRx);
class _GraphQL {
    constructor(operationKind, operationName, variables, response) {
        this.operationKind = operationKind;
        this.operationName = operationName;
        this.variables = variables;
        this.response = response;
        this._id = 48;
    }
    encode(writer) {
        return writer.uint(48) &&
            writer.string(this.operationKind) &&
            writer.string(this.operationName) &&
            writer.string(this.variables) &&
            writer.string(this.response);
    }
}
exports.GraphQL = bindNew(_GraphQL);
exports.classes.set(48, exports.GraphQL);
class _PerformanceTrack {
    constructor(frames, ticks, totalJSHeapSize, usedJSHeapSize) {
        this.frames = frames;
        this.ticks = ticks;
        this.totalJSHeapSize = totalJSHeapSize;
        this.usedJSHeapSize = usedJSHeapSize;
        this._id = 49;
    }
    encode(writer) {
        return writer.uint(49) &&
            writer.int(this.frames) &&
            writer.int(this.ticks) &&
            writer.uint(this.totalJSHeapSize) &&
            writer.uint(this.usedJSHeapSize);
    }
}
exports.PerformanceTrack = bindNew(_PerformanceTrack);
exports.classes.set(49, exports.PerformanceTrack);
class _ResourceTiming {
    constructor(timestamp, duration, ttfb, headerSize, encodedBodySize, decodedBodySize, url, initiator) {
        this.timestamp = timestamp;
        this.duration = duration;
        this.ttfb = ttfb;
        this.headerSize = headerSize;
        this.encodedBodySize = encodedBodySize;
        this.decodedBodySize = decodedBodySize;
        this.url = url;
        this.initiator = initiator;
        this._id = 53;
    }
    encode(writer) {
        return writer.uint(53) &&
            writer.uint(this.timestamp) &&
            writer.uint(this.duration) &&
            writer.uint(this.ttfb) &&
            writer.uint(this.headerSize) &&
            writer.uint(this.encodedBodySize) &&
            writer.uint(this.decodedBodySize) &&
            writer.string(this.url) &&
            writer.string(this.initiator);
    }
}
exports.ResourceTiming = bindNew(_ResourceTiming);
exports.classes.set(53, exports.ResourceTiming);
class _ConnectionInformation {
    constructor(downlink, type) {
        this.downlink = downlink;
        this.type = type;
        this._id = 54;
    }
    encode(writer) {
        return writer.uint(54) &&
            writer.uint(this.downlink) &&
            writer.string(this.type);
    }
}
exports.ConnectionInformation = bindNew(_ConnectionInformation);
exports.classes.set(54, exports.ConnectionInformation);
class _SetPageVisibility {
    constructor(hidden) {
        this.hidden = hidden;
        this._id = 55;
    }
    encode(writer) {
        return writer.uint(55) &&
            writer.boolean(this.hidden);
    }
}
exports.SetPageVisibility = bindNew(_SetPageVisibility);
exports.classes.set(55, exports.SetPageVisibility);
class _LongTask {
    constructor(timestamp, duration, context, containerType, containerSrc, containerId, containerName) {
        this.timestamp = timestamp;
        this.duration = duration;
        this.context = context;
        this.containerType = containerType;
        this.containerSrc = containerSrc;
        this.containerId = containerId;
        this.containerName = containerName;
        this._id = 59;
    }
    encode(writer) {
        return writer.uint(59) &&
            writer.uint(this.timestamp) &&
            writer.uint(this.duration) &&
            writer.uint(this.context) &&
            writer.uint(this.containerType) &&
            writer.string(this.containerSrc) &&
            writer.string(this.containerId) &&
            writer.string(this.containerName);
    }
}
exports.LongTask = bindNew(_LongTask);
exports.classes.set(59, exports.LongTask);
class _SetNodeAttributeURLBased {
    constructor(id, name, value, baseURL) {
        this.id = id;
        this.name = name;
        this.value = value;
        this.baseURL = baseURL;
        this._id = 60;
    }
    encode(writer) {
        return writer.uint(60) &&
            writer.uint(this.id) &&
            writer.string(this.name) &&
            writer.string(this.value) &&
            writer.string(this.baseURL);
    }
}
exports.SetNodeAttributeURLBased = bindNew(_SetNodeAttributeURLBased);
exports.classes.set(60, exports.SetNodeAttributeURLBased);
class _SetCSSDataURLBased {
    constructor(id, data, baseURL) {
        this.id = id;
        this.data = data;
        this.baseURL = baseURL;
        this._id = 61;
    }
    encode(writer) {
        return writer.uint(61) &&
            writer.uint(this.id) &&
            writer.string(this.data) &&
            writer.string(this.baseURL);
    }
}
exports.SetCSSDataURLBased = bindNew(_SetCSSDataURLBased);
exports.classes.set(61, exports.SetCSSDataURLBased);
class _TechnicalInfo {
    constructor(type, value) {
        this.type = type;
        this.value = value;
        this._id = 63;
    }
    encode(writer) {
        return writer.uint(63) &&
            writer.string(this.type) &&
            writer.string(this.value);
    }
}
exports.TechnicalInfo = bindNew(_TechnicalInfo);
exports.classes.set(63, exports.TechnicalInfo);
class _CustomIssue {
    constructor(name, payload) {
        this.name = name;
        this.payload = payload;
        this._id = 64;
    }
    encode(writer) {
        return writer.uint(64) &&
            writer.string(this.name) &&
            writer.string(this.payload);
    }
}
exports.CustomIssue = bindNew(_CustomIssue);
exports.classes.set(64, exports.CustomIssue);
class _PageClose {
    constructor() {
        this._id = 65;
    }
    encode(writer) {
        return writer.uint(65);
    }
}
exports.PageClose = bindNew(_PageClose);
exports.classes.set(65, exports.PageClose);
class _CSSInsertRuleURLBased {
    constructor(id, rule, index, baseURL) {
        this.id = id;
        this.rule = rule;
        this.index = index;
        this.baseURL = baseURL;
        this._id = 67;
    }
    encode(writer) {
        return writer.uint(67) &&
            writer.uint(this.id) &&
            writer.string(this.rule) &&
            writer.uint(this.index) &&
            writer.string(this.baseURL);
    }
}
exports.CSSInsertRuleURLBased = bindNew(_CSSInsertRuleURLBased);
exports.classes.set(67, exports.CSSInsertRuleURLBased);
class _MouseClick {
    constructor(id, hesitationTime, label, selector) {
        this.id = id;
        this.hesitationTime = hesitationTime;
        this.label = label;
        this.selector = selector;
        this._id = 69;
    }
    encode(writer) {
        return writer.uint(69) &&
            writer.uint(this.id) &&
            writer.uint(this.hesitationTime) &&
            writer.string(this.label) &&
            writer.string(this.selector);
    }
}
exports.MouseClick = bindNew(_MouseClick);
exports.classes.set(69, exports.MouseClick);
class _CreateIFrameDocument {
    constructor(frameID, id) {
        this.frameID = frameID;
        this.id = id;
        this._id = 70;
    }
    encode(writer) {
        return writer.uint(70) &&
            writer.uint(this.frameID) &&
            writer.uint(this.id);
    }
}
exports.CreateIFrameDocument = bindNew(_CreateIFrameDocument);
exports.classes.set(70, exports.CreateIFrameDocument);


/***/ }),

/***/ 32042:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const index_js_1 = __webpack_require__(78067);
function default_1(app) {
    const connection = navigator.connection ||
        navigator.mozConnection ||
        navigator.webkitConnection;
    if (connection === undefined) {
        return;
    }
    const sendConnectionInformation = () => app.send(new index_js_1.ConnectionInformation(Math.round(connection.downlink * 1000), connection.type || 'unknown'));
    sendConnectionInformation();
    connection.addEventListener('change', sendConnectionInformation);
}
exports["default"] = default_1;


/***/ }),

/***/ 21217:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const utils_js_1 = __webpack_require__(80901);
const index_js_1 = __webpack_require__(78067);
const printError = utils_js_1.IN_BROWSER && 'InstallTrigger' in window // detect Firefox
    ? (e) => e.message + '\n' + e.stack
    : (e) => e.stack || e.message;
function printString(arg) {
    if (arg === undefined) {
        return 'undefined';
    }
    if (arg === null) {
        return 'null';
    }
    if (arg instanceof Error) {
        return printError(arg);
    }
    if (Array.isArray(arg)) {
        return `Array(${arg.length})`;
    }
    return String(arg);
}
function printFloat(arg) {
    if (typeof arg !== 'number')
        return 'NaN';
    return arg.toString();
}
function printInt(arg) {
    if (typeof arg !== 'number')
        return 'NaN';
    return Math.floor(arg).toString();
}
function printObject(arg) {
    if (arg === undefined) {
        return 'undefined';
    }
    if (arg === null) {
        return 'null';
    }
    if (arg instanceof Error) {
        return printError(arg);
    }
    if (Array.isArray(arg)) {
        const length = arg.length;
        const values = arg.slice(0, 10).map(printString).join(', ');
        return `Array(${length})[${values}]`;
    }
    if (typeof arg === 'object') {
        const res = [];
        let i = 0;
        for (const k in arg) {
            if (++i === 10) {
                break;
            }
            const v = arg[k];
            res.push(k + ': ' + printString(v));
        }
        return '{' + res.join(', ') + '}';
    }
    return arg.toString();
}
function printf(args) {
    if (typeof args[0] === 'string') {
        args.unshift(args.shift().replace(/%(o|s|f|d|i)/g, (s, t) => {
            const arg = args.shift();
            if (arg === undefined)
                return s;
            switch (t) {
                case 'o':
                    return printObject(arg);
                case 's':
                    return printString(arg);
                case 'f':
                    return printFloat(arg);
                case 'd':
                case 'i':
                    return printInt(arg);
                default:
                    return s;
            }
        }));
    }
    return args.map(printObject).join(' ');
}
const consoleMethods = ['log', 'info', 'warn', 'error', 'debug', 'assert'];
function default_1(app, opts) {
    const options = Object.assign({
        consoleMethods,
        consoleThrottling: 30,
    }, opts);
    if (!Array.isArray(options.consoleMethods) ||
        options.consoleMethods.length === 0) {
        return;
    }
    const sendConsoleLog = app.safe((level, args) => app.send(new index_js_1.ConsoleLog(level, printf(args))));
    let n;
    const reset = () => {
        n = 0;
    };
    app.attachStartCallback(reset);
    app.ticker.attach(reset, 33, false);
    const patchConsole = (console) => options.consoleMethods.forEach((method) => {
        if (consoleMethods.indexOf(method) === -1) {
            console.error(`OpenReplay: unsupported console method "${method}"`);
            return;
        }
        const fn = console[method];
        console[method] = function (...args) {
            fn.apply(this, args);
            if (n++ > options.consoleThrottling) {
                return;
            }
            sendConsoleLog(method, args);
        };
    });
    patchConsole(window.console);
    app.nodes.attachNodeCallback(app.safe(node => {
        if (node instanceof HTMLIFrameElement) {
            let context = node.contentWindow;
            if (context) {
                patchConsole(context.console);
            }
            app.attachEventListener(node, "load", () => {
                if (node.contentWindow !== context) {
                    context = node.contentWindow;
                    patchConsole(context.console);
                }
            });
        }
    }));
}
exports["default"] = default_1;


/***/ }),

/***/ 14312:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const index_js_1 = __webpack_require__(78067);
function default_1(app) {
    if (app === null) {
        return;
    }
    if (!window.CSSStyleSheet) {
        app.send(new index_js_1.TechnicalInfo("no_stylesheet_prototype_in_window", ""));
        return;
    }
    const processOperation = app.safe((stylesheet, index, rule) => {
        const sendMessage = typeof rule === 'string'
            ? (nodeID) => app.send(new index_js_1.CSSInsertRuleURLBased(nodeID, rule, index, app.getBaseHref()))
            : (nodeID) => app.send(new index_js_1.CSSDeleteRule(nodeID, index));
        // TODO: Extend messages to maintain nested rules (CSSGroupingRule prototype, as well as CSSKeyframesRule)
        if (stylesheet.ownerNode == null) {
            throw new Error("Owner Node not found");
        }
        const nodeID = app.nodes.getID(stylesheet.ownerNode);
        if (nodeID !== undefined) {
            sendMessage(nodeID);
        } // else error?
    });
    const { insertRule, deleteRule } = CSSStyleSheet.prototype;
    CSSStyleSheet.prototype.insertRule = function (rule, index = 0) {
        processOperation(this, index, rule);
        return insertRule.call(this, rule, index);
    };
    CSSStyleSheet.prototype.deleteRule = function (index) {
        processOperation(this, index);
        return deleteRule.call(this, index);
    };
    app.nodes.attachNodeCallback((node) => {
        if (!(node instanceof HTMLStyleElement)) {
            return;
        }
        if (!(node.sheet instanceof CSSStyleSheet)) {
            return;
        }
        if (node.textContent !== null && node.textContent.trim().length > 0) {
            return; // Only fully virtual sheets maintained so far
        }
        const rules = node.sheet.cssRules;
        for (let i = 0; i < rules.length; i++) {
            processOperation(node.sheet, i, rules[i].cssText);
        }
    });
}
exports["default"] = default_1;


/***/ }),

/***/ 76978:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getExceptionMessageFromEvent = exports.getExceptionMessage = void 0;
const index_js_1 = __webpack_require__(78067);
const error_stack_parser_1 = __webpack_require__(78816);
function getDefaultStack(e) {
    return [{
            columnNumber: e.colno,
            lineNumber: e.lineno,
            fileName: e.filename,
            functionName: "",
            source: "",
        }];
}
function getExceptionMessage(error, fallbackStack) {
    let stack = fallbackStack;
    try {
        stack = error_stack_parser_1.default.parse(error);
    }
    catch (e) {
    }
    return new index_js_1.JSException(error.name, error.message, JSON.stringify(stack));
}
exports.getExceptionMessage = getExceptionMessage;
function getExceptionMessageFromEvent(e) {
    if (e instanceof ErrorEvent) {
        if (e.error instanceof Error) {
            return getExceptionMessage(e.error, getDefaultStack(e));
        }
        else {
            let [name, message] = e.message.split(':');
            if (!message) {
                name = 'Error';
                message = e.message;
            }
            return new index_js_1.JSException(name, message, JSON.stringify(getDefaultStack(e)));
        }
    }
    else if ('PromiseRejectionEvent' in window && e instanceof PromiseRejectionEvent) {
        if (e.reason instanceof Error) {
            return getExceptionMessage(e.reason, []);
        }
        else {
            let message;
            try {
                message = JSON.stringify(e.reason);
            }
            catch (_) {
                message = String(e.reason);
            }
            return new index_js_1.JSException('Unhandled Promise Rejection', message, '[]');
        }
    }
    return null;
}
exports.getExceptionMessageFromEvent = getExceptionMessageFromEvent;
function default_1(app, opts) {
    const options = Object.assign({
        captureExceptions: true,
    }, opts);
    if (options.captureExceptions) {
        const handler = (e) => {
            const msg = getExceptionMessageFromEvent(e);
            if (msg != null) {
                app.send(msg);
            }
        };
        app.attachEventListener(window, 'unhandledrejection', (e) => handler(e));
        app.attachEventListener(window, 'error', (e) => handler(e));
    }
}
exports["default"] = default_1;


/***/ }),

/***/ 72107:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const utils_js_1 = __webpack_require__(80901);
const index_js_1 = __webpack_require__(78067);
const PLACEHOLDER_SRC = "https://static.openreplay.com/tracker/placeholder.jpeg";
function default_1(app) {
    function sendPlaceholder(id, node) {
        app.send(new index_js_1.SetNodeAttribute(id, "src", PLACEHOLDER_SRC));
        const { width, height } = node.getBoundingClientRect();
        if (!node.hasAttribute("width")) {
            app.send(new index_js_1.SetNodeAttribute(id, "width", String(width)));
        }
        if (!node.hasAttribute("height")) {
            app.send(new index_js_1.SetNodeAttribute(id, "height", String(height)));
        }
    }
    const sendImgSrc = app.safe(function () {
        const id = app.nodes.getID(this);
        if (id === undefined) {
            return;
        }
        const { src, complete, naturalWidth, naturalHeight } = this;
        if (!complete) {
            return;
        }
        if (naturalWidth === 0 && naturalHeight === 0) {
            if (src != null && (0, utils_js_1.isURL)(src)) { // TODO: How about relative urls ? Src type is null sometimes.
                app.send(new index_js_1.ResourceTiming((0, utils_js_1.timestamp)(), 0, 0, 0, 0, 0, src, 'img'));
            }
        }
        else if (src.length >= 1e5 || app.sanitizer.isMasked(id)) {
            sendPlaceholder(id, this);
        }
        else {
            app.send(new index_js_1.SetNodeAttributeURLBased(id, 'src', src, app.getBaseHref()));
        }
    });
    const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
            if (mutation.type === "attributes" && mutation.attributeName === "src") {
                const target = mutation.target;
                const id = app.nodes.getID(target);
                if (id === undefined) {
                    return;
                }
                const src = target.src;
                app.send(new index_js_1.SetNodeAttributeURLBased(id, 'src', src, app.getBaseHref()));
            }
        }
    });
    app.nodes.attachNodeCallback((node) => {
        if (!(node instanceof HTMLImageElement)) {
            return;
        }
        app.nodes.attachElementListener('error', node, sendImgSrc);
        app.nodes.attachElementListener('load', node, sendImgSrc);
        sendImgSrc.call(node);
        observer.observe(node, { attributes: true });
    });
}
exports["default"] = default_1;


/***/ }),

/***/ 34134:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getInputLabel = void 0;
const utils_js_1 = __webpack_require__(80901);
const index_js_1 = __webpack_require__(78067);
function isTextEditable(node) {
    if (node instanceof HTMLTextAreaElement) {
        return true;
    }
    if (!(node instanceof HTMLInputElement)) {
        return false;
    }
    const type = node.type;
    return (type === 'text' ||
        type === 'password' ||
        type === 'email' ||
        type === 'search' ||
        type === 'number' ||
        type === 'range');
}
function isCheckable(node) {
    if (!(node instanceof HTMLInputElement)) {
        return false;
    }
    const type = node.type;
    return type === 'checkbox' || type === 'radio';
}
const labelElementFor = utils_js_1.IN_BROWSER && 'labels' in HTMLInputElement.prototype
    ? (node) => {
        let p = node;
        while ((p = p.parentNode) !== null) {
            if (p.nodeName === 'LABEL') {
                return p;
            }
        }
        const labels = node.labels;
        if (labels !== null && labels.length === 1) {
            return labels[0];
        }
    }
    : (node) => {
        let p = node;
        while ((p = p.parentNode) !== null) {
            if (p.nodeName === 'LABEL') {
                return p;
            }
        }
        const id = node.id;
        if (id) {
            const labels = document.querySelectorAll('label[for="' + id + '"]');
            if (labels !== null && labels.length === 1) {
                return labels[0];
            }
        }
    };
function getInputLabel(node) {
    let label = (0, utils_js_1.getLabelAttribute)(node);
    if (label === null) {
        const labelElement = labelElementFor(node);
        label =
            labelElement === undefined
                ? node.placeholder || node.name
                : labelElement.innerText;
    }
    return (0, utils_js_1.normSpaces)(label).slice(0, 100);
}
exports.getInputLabel = getInputLabel;
function default_1(app, opts) {
    const options = Object.assign({
        obscureInputNumbers: true,
        obscureInputEmails: true,
        defaultInputMode: 0 /* Plain */,
    }, opts);
    function sendInputTarget(id, node) {
        const label = getInputLabel(node);
        if (label !== '') {
            app.send(new index_js_1.SetInputTarget(id, label));
        }
    }
    function sendInputValue(id, node) {
        let value = node.value;
        let inputMode = options.defaultInputMode;
        if (node.type === 'password' || (0, utils_js_1.hasOpenreplayAttribute)(node, 'hidden')) {
            inputMode = 2 /* Hidden */;
        }
        else if ((0, utils_js_1.hasOpenreplayAttribute)(node, 'obscured') ||
            (inputMode === 0 /* Plain */ &&
                ((options.obscureInputNumbers && /\d\d\d\d/.test(value)) ||
                    (options.obscureInputEmails &&
                        (node.type === 'email' || !!~value.indexOf('@')))))) {
            inputMode = 1 /* Obscured */;
        }
        let mask = 0;
        switch (inputMode) {
            case 2 /* Hidden */:
                mask = -1;
                value = '';
                break;
            case 1 /* Obscured */:
                mask = value.length;
                value = '';
                break;
        }
        app.send(new index_js_1.SetInputValue(id, value, mask));
    }
    const inputValues = new Map();
    const checkableValues = new Map();
    const registeredTargets = new Set();
    app.attachStopCallback(() => {
        inputValues.clear();
        checkableValues.clear();
        registeredTargets.clear();
    });
    app.ticker.attach(() => {
        inputValues.forEach((value, id) => {
            const node = app.nodes.getNode(id);
            if (!isTextEditable(node)) {
                inputValues.delete(id);
                return;
            }
            if (value !== node.value) {
                inputValues.set(id, node.value);
                if (!registeredTargets.has(id)) {
                    registeredTargets.add(id);
                    sendInputTarget(id, node);
                }
                sendInputValue(id, node);
            }
        });
        checkableValues.forEach((checked, id) => {
            const node = app.nodes.getNode(id);
            if (!isCheckable(node)) {
                checkableValues.delete(id);
                return;
            }
            if (checked !== node.checked) {
                checkableValues.set(id, node.checked);
                app.send(new index_js_1.SetInputChecked(id, node.checked));
            }
        });
    });
    app.ticker.attach(Set.prototype.clear, 100, false, registeredTargets);
    app.nodes.attachNodeCallback(app.safe((node) => {
        const id = app.nodes.getID(node);
        if (id === undefined) {
            return;
        }
        if (isTextEditable(node)) {
            inputValues.set(id, node.value);
            sendInputValue(id, node);
            return;
        }
        if (isCheckable(node)) {
            checkableValues.set(id, node.checked);
            app.send(new index_js_1.SetInputChecked(id, node.checked));
            return;
        }
    }));
}
exports["default"] = default_1;


/***/ }),

/***/ 21495:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const utils_js_1 = __webpack_require__(80901);
const index_js_1 = __webpack_require__(78067);
const input_js_1 = __webpack_require__(34134);
function _getSelector(target) {
    let el = target;
    let selector = null;
    do {
        if (el.id) {
            return `#${el.id}` + (selector ? ` > ${selector}` : '');
        }
        selector =
            el.className.split(' ')
                .map(cn => cn.trim())
                .filter(cn => cn !== '')
                .reduce((sel, cn) => `${sel}.${cn}`, el.tagName.toLowerCase()) +
                (selector ? ` > ${selector}` : '');
        if (el === document.body) {
            return selector;
        }
        el = el.parentElement;
    } while (el !== document.body && el !== null);
    return selector;
}
//TODO: fix (typescript doesn't allow work when the guard is inside the function)
function getTarget(target) {
    if (target instanceof Element) {
        return _getTarget(target);
    }
    return null;
}
function _getTarget(target) {
    let element = target;
    while (element !== null && element !== document.documentElement) {
        if ((0, utils_js_1.hasOpenreplayAttribute)(element, 'masked')) {
            return null;
        }
        element = element.parentElement;
    }
    if (target instanceof SVGElement) {
        let owner = target.ownerSVGElement;
        while (owner !== null) {
            target = owner;
            owner = owner.ownerSVGElement;
        }
    }
    element = target;
    while (element !== null && element !== document.documentElement) {
        const tag = element.tagName.toUpperCase();
        if (tag === 'LABEL') {
            return null;
        }
        if (tag === 'INPUT') {
            return element;
        }
        if (tag === 'BUTTON' ||
            tag === 'A' ||
            tag === 'LI' ||
            tag === 'SELECT' ||
            element.onclick != null ||
            element.getAttribute('role') === 'button' ||
            (0, utils_js_1.getLabelAttribute)(element) !== null) {
            return element;
        }
        element = element.parentElement;
    }
    return target === document.documentElement ? null : target;
}
function default_1(app) {
    // const options: Options = Object.assign(
    //   {},
    //   opts,
    // );
    function getTargetLabel(target) {
        const dl = (0, utils_js_1.getLabelAttribute)(target);
        if (dl !== null) {
            return dl;
        }
        const tag = target.tagName.toUpperCase();
        if (tag === 'INPUT') {
            return (0, input_js_1.getInputLabel)(target);
        }
        if (tag === 'BUTTON' ||
            tag === 'A' ||
            tag === 'LI' ||
            tag === 'SELECT' ||
            target.onclick != null ||
            target.getAttribute('role') === 'button') {
            const label = app.sanitizer.getInnerTextSecure(target);
            return (0, utils_js_1.normSpaces)(label).slice(0, 100);
        }
        return '';
    }
    let mousePositionX = -1;
    let mousePositionY = -1;
    let mousePositionChanged = false;
    let mouseTarget = null;
    let mouseTargetTime = 0;
    app.attachStopCallback(() => {
        mousePositionX = -1;
        mousePositionY = -1;
        mousePositionChanged = false;
        mouseTarget = null;
    });
    const sendMouseMove = () => {
        if (mousePositionChanged) {
            app.send(new index_js_1.MouseMove(mousePositionX, mousePositionY));
            mousePositionChanged = false;
        }
    };
    const selectorMap = {};
    function getSelector(id, target) {
        return selectorMap[id] = selectorMap[id] || _getSelector(target);
    }
    app.attachEventListener(document.documentElement, 'mouseover', (e) => {
        const target = getTarget(e.target);
        if (target !== mouseTarget) {
            mouseTarget = target;
            mouseTargetTime = performance.now();
        }
    });
    app.attachEventListener(document, 'mousemove', (e) => {
        mousePositionX = e.clientX;
        mousePositionY = e.clientY;
        mousePositionChanged = true;
    }, false);
    app.attachEventListener(document, 'click', (e) => {
        const target = getTarget(e.target);
        if ((!e.clientX && !e.clientY) || target === null) {
            return;
        }
        const id = app.nodes.getID(target);
        if (id !== undefined) {
            sendMouseMove();
            app.send(new index_js_1.MouseClick(id, mouseTarget === target
                ? Math.round(performance.now() - mouseTargetTime)
                : 0, getTargetLabel(target), getSelector(id, target)), true);
        }
        mouseTarget = null;
    });
    app.ticker.attach(sendMouseMove, 10);
}
exports["default"] = default_1;


/***/ }),

/***/ 86033:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.jsHeapSizeLimit = exports.deviceMemory = void 0;
const utils_js_1 = __webpack_require__(80901);
const index_js_1 = __webpack_require__(78067);
const perf = utils_js_1.IN_BROWSER && 'performance' in window && 'memory' in performance // works in Chrome only
    ? performance
    : { memory: {} };
exports.deviceMemory = utils_js_1.IN_BROWSER ? (navigator.deviceMemory || 0) * 1024 : 0;
exports.jsHeapSizeLimit = perf.memory.jsHeapSizeLimit || 0;
function default_1(app, opts) {
    const options = Object.assign({
        capturePerformance: true,
    }, opts);
    if (!options.capturePerformance) {
        return;
    }
    let frames;
    let ticks;
    const nextFrame = () => {
        if (frames === undefined || frames === -1) {
            return;
        }
        frames++;
        requestAnimationFrame(nextFrame);
    };
    app.ticker.attach(() => {
        if (ticks === undefined || ticks === -1) {
            return;
        }
        ticks++;
    }, 0, false);
    const sendPerformanceTrack = () => {
        if (frames === undefined || ticks === undefined) {
            return;
        }
        app.send(new index_js_1.PerformanceTrack(frames, ticks, perf.memory.totalJSHeapSize || 0, perf.memory.usedJSHeapSize || 0));
        ticks = frames = document.hidden ? -1 : 0;
    };
    app.attachStartCallback(() => {
        ticks = frames = -1;
        sendPerformanceTrack();
        nextFrame();
    });
    app.attachStopCallback(() => {
        ticks = frames = undefined;
    });
    app.ticker.attach(sendPerformanceTrack, 40, false);
    if (document.hidden !== undefined) {
        app.attachEventListener(document, 'visibilitychange', sendPerformanceTrack, false, false);
    }
}
exports["default"] = default_1;


/***/ }),

/***/ 20185:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const index_js_1 = __webpack_require__(78067);
function default_1(app) {
    let documentScroll = false;
    const nodeScroll = new Map();
    const sendSetViewportScroll = app.safe(() => app.send(new index_js_1.SetViewportScroll(window.pageXOffset ||
        (document.documentElement && document.documentElement.scrollLeft) ||
        (document.body && document.body.scrollLeft) ||
        0, window.pageYOffset ||
        (document.documentElement && document.documentElement.scrollTop) ||
        (document.body && document.body.scrollTop) ||
        0)));
    const sendSetNodeScroll = app.safe((s, node) => {
        const id = app.nodes.getID(node);
        if (id !== undefined) {
            app.send(new index_js_1.SetNodeScroll(id, s[0], s[1]));
        }
    });
    app.attachStartCallback(sendSetViewportScroll);
    app.attachStopCallback(() => {
        documentScroll = false;
        nodeScroll.clear();
    });
    app.attachEventListener(window, 'scroll', (e) => {
        const target = e.target;
        if (target === document) {
            documentScroll = true;
            return;
        }
        if (target instanceof Element) {
            {
                nodeScroll.set(target, [target.scrollLeft, target.scrollTop]);
            }
        }
    });
    app.ticker.attach(() => {
        if (documentScroll) {
            sendSetViewportScroll();
            documentScroll = false;
        }
        nodeScroll.forEach(sendSetNodeScroll);
        nodeScroll.clear();
    }, 5, false);
}
exports["default"] = default_1;


/***/ }),

/***/ 48342:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const utils_js_1 = __webpack_require__(80901);
const index_js_1 = __webpack_require__(78067);
function getPaintBlocks(resources) {
    const paintBlocks = [];
    const elements = document.getElementsByTagName('*');
    const styleURL = /url\(("[^"]*"|'[^']*'|[^)]*)\)/i;
    for (let i = 0; i < elements.length; i++) {
        const element = elements[i];
        let src = '';
        if (element instanceof HTMLImageElement) {
            src = element.currentSrc || element.src;
        }
        if (!src) {
            const backgroundImage = getComputedStyle(element).getPropertyValue('background-image');
            if (backgroundImage) {
                const matches = styleURL.exec(backgroundImage);
                if (matches !== null) {
                    src = matches[1];
                    if (src.startsWith('"') || src.startsWith("'")) {
                        src = src.substr(1, src.length - 2);
                    }
                }
            }
        }
        if (!src)
            continue;
        const time = src.substr(0, 10) === 'data:image' ? 0 : resources[src];
        if (time === undefined)
            continue;
        const rect = element.getBoundingClientRect();
        const top = Math.max(rect.top, 0);
        const left = Math.max(rect.left, 0);
        const bottom = Math.min(rect.bottom, window.innerHeight ||
            (document.documentElement && document.documentElement.clientHeight) ||
            0);
        const right = Math.min(rect.right, window.innerWidth ||
            (document.documentElement && document.documentElement.clientWidth) ||
            0);
        if (bottom <= top || right <= left)
            continue;
        const area = (bottom - top) * (right - left);
        paintBlocks.push({ time, area });
    }
    return paintBlocks;
}
function calculateSpeedIndex(firstContentfulPaint, paintBlocks) {
    let a = (Math.max((document.documentElement && document.documentElement.clientWidth) || 0, window.innerWidth || 0) *
        Math.max((document.documentElement && document.documentElement.clientHeight) ||
            0, window.innerHeight || 0)) /
        10;
    let s = a * firstContentfulPaint;
    for (let i = 0; i < paintBlocks.length; i++) {
        const { time, area } = paintBlocks[i];
        a += area;
        s += area * (time > firstContentfulPaint ? time : firstContentfulPaint);
    }
    return a === 0 ? 0 : s / a;
}
function default_1(app, opts) {
    const options = Object.assign({
        captureResourceTimings: true,
        capturePageLoadTimings: true,
        capturePageRenderTimings: true,
    }, opts);
    if (!('PerformanceObserver' in window)) {
        options.captureResourceTimings = false;
    }
    if (!options.captureResourceTimings) {
        return;
    } // Resources are necessary for all timings
    const mQueue = [];
    function sendOnStart(m) {
        if (app.active()) {
            app.send(m);
        }
        else {
            mQueue.push(m);
        }
    }
    app.attachStartCallback(function () {
        mQueue.forEach(m => app.send(m));
    });
    let resources = {};
    function resourceTiming(entry) {
        if (entry.duration < 0 || !(0, utils_js_1.isURL)(entry.name) || app.isServiceURL(entry.name))
            return;
        if (resources !== null) {
            resources[entry.name] = entry.startTime + entry.duration;
        }
        sendOnStart(new index_js_1.ResourceTiming(entry.startTime + performance.timing.navigationStart, entry.duration, entry.responseStart && entry.startTime
            ? entry.responseStart - entry.startTime
            : 0, entry.transferSize > entry.encodedBodySize
            ? entry.transferSize - entry.encodedBodySize
            : 0, entry.encodedBodySize || 0, entry.decodedBodySize || 0, entry.name, entry.initiatorType));
    }
    const observer = new PerformanceObserver((list) => list.getEntries().forEach(resourceTiming));
    performance.getEntriesByType('resource').forEach(resourceTiming);
    observer.observe({ entryTypes: ['resource'] });
    let firstPaint = 0, firstContentfulPaint = 0;
    if (options.capturePageLoadTimings) {
        let pageLoadTimingSent = false;
        app.ticker.attach(() => {
            if (pageLoadTimingSent) {
                return;
            }
            if (firstPaint === 0 || firstContentfulPaint === 0) {
                performance
                    .getEntriesByType('paint')
                    .forEach((entry) => {
                    const { name, startTime } = entry;
                    switch (name) {
                        case 'first-paint':
                            firstPaint = startTime;
                            break;
                        case 'first-contentful-paint':
                            firstContentfulPaint = startTime;
                            break;
                    }
                });
            }
            if (performance.timing.loadEventEnd || performance.now() > 30000) {
                pageLoadTimingSent = true;
                const { navigationStart, requestStart, responseStart, responseEnd, domContentLoadedEventStart, domContentLoadedEventEnd, loadEventStart, loadEventEnd, } = performance.timing;
                app.send(new index_js_1.PageLoadTiming(requestStart - navigationStart || 0, responseStart - navigationStart || 0, responseEnd - navigationStart || 0, domContentLoadedEventStart - navigationStart || 0, domContentLoadedEventEnd - navigationStart || 0, loadEventStart - navigationStart || 0, loadEventEnd - navigationStart || 0, firstPaint, firstContentfulPaint));
            }
        }, 30);
    }
    if (options.capturePageRenderTimings) {
        let visuallyComplete = 0, interactiveWindowStartTime = 0, interactiveWindowTickTime = 0, paintBlocks = null;
        let pageRenderTimingSent = false;
        app.ticker.attach(() => {
            if (pageRenderTimingSent) {
                return;
            }
            const time = performance.now();
            if (resources !== null) {
                visuallyComplete = Math.max.apply(null, Object.keys(resources).map((k) => resources[k]));
                if (time - visuallyComplete > 1000) {
                    paintBlocks = getPaintBlocks(resources);
                    resources = null;
                }
            }
            if (interactiveWindowTickTime !== null) {
                if (time - interactiveWindowTickTime > 50) {
                    interactiveWindowStartTime = time;
                }
                interactiveWindowTickTime =
                    time - interactiveWindowStartTime > 5000 ? null : time;
            }
            if ((paintBlocks !== null && interactiveWindowTickTime === null) ||
                time > 30000) {
                pageRenderTimingSent = true;
                resources = null;
                const speedIndex = paintBlocks === null
                    ? 0
                    : calculateSpeedIndex(firstContentfulPaint || firstPaint, paintBlocks);
                const timeToInteractive = interactiveWindowTickTime === null
                    ? Math.max(interactiveWindowStartTime, firstContentfulPaint, performance.timing.domContentLoadedEventEnd -
                        performance.timing.navigationStart || 0)
                    : 0;
                app.send(new index_js_1.PageRenderTiming(speedIndex, firstContentfulPaint > visuallyComplete
                    ? firstContentfulPaint
                    : visuallyComplete, timeToInteractive));
            }
        });
    }
}
exports["default"] = default_1;


/***/ }),

/***/ 46310:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const index_js_1 = __webpack_require__(78067);
function default_1(app) {
    let url, width, height;
    let navigationStart = performance.timing.navigationStart;
    const sendSetPageLocation = app.safe(() => {
        const { URL } = document;
        if (URL !== url) {
            url = URL;
            app.send(new index_js_1.SetPageLocation(url, document.referrer, navigationStart));
            navigationStart = 0;
        }
    });
    const sendSetViewportSize = app.safe(() => {
        const { innerWidth, innerHeight } = window;
        if (innerWidth !== width || innerHeight !== height) {
            width = innerWidth;
            height = innerHeight;
            app.send(new index_js_1.SetViewportSize(width, height));
        }
    });
    const sendSetPageVisibility = document.hidden === undefined
        ? Function.prototype
        : app.safe(() => app.send(new index_js_1.SetPageVisibility(document.hidden)));
    app.attachStartCallback(() => {
        url = '';
        width = height = -1;
        sendSetPageLocation();
        sendSetViewportSize();
        sendSetPageVisibility();
    });
    if (document.hidden !== undefined) {
        app.attachEventListener(document, 'visibilitychange', sendSetPageVisibility, false, false);
    }
    app.ticker.attach(sendSetPageLocation, 1, false);
    app.ticker.attach(sendSetViewportSize, 5, false);
}
exports["default"] = default_1;


/***/ }),

/***/ 80901:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.hasOpenreplayAttribute = exports.getLabelAttribute = exports.deprecationWarn = exports.DOCS_HOST = exports.IN_BROWSER = exports.isURL = exports.normSpaces = exports.stars = exports.timestamp = void 0;
function timestamp() {
    return Math.round(performance.now()) + performance.timing.navigationStart;
}
exports.timestamp = timestamp;
exports.stars = 'repeat' in String.prototype
    ? (str) => '*'.repeat(str.length)
    : (str) => str.replace(/./g, '*');
function normSpaces(str) {
    return str.trim().replace(/\s+/g, ' ');
}
exports.normSpaces = normSpaces;
// isAbsoluteUrl regexp:  /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url)
function isURL(s) {
    return s.substr(0, 8) === 'https://' || s.substr(0, 7) === 'http://';
}
exports.isURL = isURL;
exports.IN_BROWSER = !(typeof window === "undefined");
// TODO: JOIN IT WITH LOGGER somehow (use logging decorators?); Don't forget about index.js loggin when there is no logger instance.
exports.DOCS_HOST = 'https://docs.openreplay.com';
const warnedFeatures = {};
function deprecationWarn(nameOfFeature, useInstead, docsPath = "/") {
    if (warnedFeatures[nameOfFeature]) {
        return;
    }
    console.warn(`OpenReplay: ${nameOfFeature} is deprecated. ${useInstead ? `Please, use ${useInstead} instead.` : ""} Visit ${exports.DOCS_HOST}${docsPath} for more information.`);
    warnedFeatures[nameOfFeature] = true;
}
exports.deprecationWarn = deprecationWarn;
function getLabelAttribute(e) {
    let value = e.getAttribute("data-openreplay-label");
    if (value !== null) {
        return value;
    }
    value = e.getAttribute("data-asayer-label");
    if (value !== null) {
        deprecationWarn(`"data-asayer-label" attribute`, `"data-openreplay-label" attribute`, "/");
    }
    return value;
}
exports.getLabelAttribute = getLabelAttribute;
function hasOpenreplayAttribute(e, name) {
    const newName = `data-openreplay-${name}`;
    if (e.hasAttribute(newName)) {
        return true;
    }
    const oldName = `data-asayer-${name}`;
    if (e.hasAttribute(oldName)) {
        deprecationWarn(`"${oldName}" attribute`, `"${newName}" attribute`, "/installation/sanitize-data");
        return true;
    }
    return false;
}
exports.hasOpenreplayAttribute = hasOpenreplayAttribute;


/***/ })

}]);